import { Component, OnInit, Input, HostListener, ChangeDetectorRef } from '@angular/core';
import { SubscriptionService } from '@app-services/subscription/subscription.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { TestRegistrationConfirmDialogComponent } from '@app-shared/components/test-registration-confirm-dialog/test-registration-confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { apisDataCacheKeys,basic_propackage,Oms_package_id, ZeroDiscountForOptimization } from '@app-constants/app.constants';
import { states } from '@subscription-constants/subscriptionconstant';
import { environment } from '@app-environments/environment';
import { NgZone } from '@angular/core';
import {GAnalyticsService} from '@app-services/g-analytics/g-analytics.service';
import {AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {Bank} from '@app-modules/feature/subscription/my-subscription-part-payment/my-subscription-part-payment.component';
import {Observable, Subscription} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {RazorpayapiService} from 'src/app/razorpayapi.service';
import {ToastrService} from 'ngx-toastr';
import { JodoPopupInfoDialogComponent } from '@app-shared/components/jodo-popup-info-dialog/jodo-popup-info-dialog.component';
import { PaymentPartnerIframeDialogComponent } from '@app-modules/feature/subscription/payment-partner-iframe-dialog/payment-partner-iframe-dialog.component';
import { getILCookie, setILCookie, setLoggedInUserData } from '@app-helpers/functions';
import { UserService } from '@app-services/user/user.service';
import { AuthService } from '@app-services/auth-service/auth.service';
import { JodoPopupComponent } from '@app-modules/feature/enrollsubscription/jodo-popup/jodo-popup.component';
declare let $: any;

@Component({
  selector: 'app-cuet-payment',
  templateUrl: './cuet-payment.component.html',
  styleUrls: ['./cuet-payment.component.scss']
})
export class CuetPaymentComponent implements OnInit {
  @Input() pacakgeSelected: any;
  @Input() validitySelected: any;
  @Input() userDetails: any;
  @Input() selectedBatch: any;
  @Input() discountCode: any;
  @Input() selectedDateAndTime: any;
  @Input() courseSelected: any;

  subscriptionbillingUtility: any = {
    selectedPackage: {},
    selectedDuration: [],
    userDetails: {},
    today: new Date(),
    stateName: '',
    discountAmount: 0,
    states: states,
    selectedDateAndTime: {},
    localUserData:{},
    courseSelected:{},
    subscriptionPacakgeIdList: [],
    packageSubscriptionAmountList: [],
    finalDTOArray: [],
    partPaymentDetailPlan: [],
    selectedCartItems: [],
    discountCodecoupounPer: 0,
    Emioptions: [],
    selectedEmiPart: 0,
    totalAmount:0,
    fulltotalAmount:0,
    emiPayLaterFulltotalAmount:0,
    totalAmount_withoutdiscount:0,
    partPaymentDiscountper:0,
    totalPaidAmount: 0,
    discountPercentage:0,
    discountType: '',
    userCartAddedScorePackageTimeslots:{},
    jodoemiOptions:[],
    freeProPackageAmount:0
  };

  paymentValue: any;
  public rzp: any;
  public options2: any;
  public openPartapaystatus: boolean = false;
  public openCartOrderReviewBoxstatus: boolean = false;
  subscription: Subscription;
  totalPartPaymentAmt: number = 0;
  jodoTotalPartPaymentAmt: number = 0;
  totalItemQuantity: number = 0;
  selectedPartOptions:any;
  jodoselectedPartOptions:any;
  partPaymentTabNo: number = 0;

  razorPayData: any;

    // custom payment variable
    paymentGatewayCode: "RAZORPAY" | "SIMPL" | "BAJAJFINANCE" | "JODO" | "SHOPSE" | "EARLY_SALARY";
    paymentType: "fullpayment" | "partpayment" = "fullpayment";
    newCardForm!: FormGroup;
    selctedCardData: any = {};
    customPaymntType: string = 'card';
    customPaymntPanelStatus:boolean = false;
    innerPanelName: string = 'addNewCard';
    jodoProductType: "CRED" | "FLEX";s
  
    // net banking dropdown variable
    selectedBankName: any;
    popularBanksList = [
      // { name: "HDFC Bank", code: "HDFC" },
      { name: "ICICI Bank", code: "ICIC" },
      { name: "AXIS Bank", code: "UTIB" },
      { name: "Kotak Mahindra Bank", code: "KKBK" },
      { name: "State Bank of India", code: "SBIN" },
      { name: "Yes Bank", code: "YESB" },
      { name: "IDBI", code: "IBKL" },
      { name: "BOB", code: "BARB_R" },
      { name: "PNB", code: "PUNB_R" },
    ];
    popularBanks = [];
    bankControlForm!: FormGroup;
    options: Bank[] = [];
    filteredOptions: Observable<Bank[]>;
  
    // UPI
    UPIControlForm!: FormGroup;
    isUPIValid: boolean = false;
    isUPIVerified: boolean = false;
    upicheckLoading: any;
    upiMode: any;
  
    // wallets
    selectedWalletCode: any;
    wallets = [];
  
    // emi
    emi_data: any = [];
    validEmiData: any;
    hasDebitCardEMI: any;
    hasCreditCardEMI: any;
    selected_bank_emi_data: any;
    selectedEmiPlan: any;
    emiMode: any;
    EMICardForm!: FormGroup;
    BajajEMICardForm!: FormGroup;
    previousExpiryDateLen: any;
    selctedEMICardData: any;
    selctedBajajEMICardData: any;
    EMICardErrorMSg: any;
    BajajEMICardErrorMSg: any;
    BajajEMIOtpErrorMSg: any;
    bajajFinanceNoCostEmiData: any = {
      showBajaj: environment.Bajaj.showBajaj,
      name: "Bajaj Finserv",
      code: "BAJAJ",
      isDisplayOtp: false,
      isNoCostEMI: true,
      min_amount: environment.Bajaj.min_amount,
      max_amount: environment.Bajaj.max_amount,
      plans: []
    };
    bajajCreateCartOrderResp: any;
    showEmiTooltip: boolean = false;
    resendotp: boolean = false;
    counter;
    cardLessEmis: any;
    selectedCardLessEmi: any;
    isCardlessEmi: boolean = false;
    isFromBajajFinservAppInApp: boolean = false;
    CardlessEMICardForm!: FormGroup;
    jodoWindow: any;
    displayJodoCred: boolean = environment?.Jodo?.websitedisplayCred;
    displayJodoFlex: boolean = environment?.Jodo?.websitedisplayFlex;
    jodoPopupWindow: any;
    jodo_cred: any = {
        min_amount: 10000,
        max_amount: 1000000,
     };
    displayShopSe: boolean = environment?.websitedisplayShopSe;
    shopSe: any = {
      min_amount: 3500,
      max_amount: 200000,
    };
    shopsePopupWindow: any;
    EarlySalaryEMICardForm!: FormGroup;
    EarlySalaryEMICardErrorMSg: any;
    EarlySalaryEMIOtpErrorMSg: any;
    displayEarlySalary: boolean = environment?.websitedisplayEarlySalary;
    earlySalary: any = {
      min_amount: 14000,
      max_amount: 500000,
      isDisplayOtp: false,
      resendotp: false,
      counter: 0,
      customerRefId: ""
    };
    earlySalaryPopupWindow: any;
  
    // paylater
    selectedPaylaterMethod: any;
    allowOpeningSimplewindow: boolean = true;
    simplEligibilityData: any;
    subcriptionPayment: any;
    ipAddress: any;
    simplWindow: any;
  
    partPayment:number;
    jodoPartPayment: any;
    jodoSinglePartPayment: any;
    lastPartPaymentDate:any;
    discountPercentage: any;
    deviceWidth:any;
  couponCode: any;
  autoApplyMarketing:boolean=false;
  isTryAgain:boolean = false;
  isTryAgainMethod:any;
  queryParams: any;
  navExtra;
  packageDeatails: any = [];
  cartItemId:any;
  billingAddress:any;
  isJodoflex:boolean = false;
  isAits:boolean = false;
  selectedCartItem:any;
  isLiveCalssPurchaseAgain:boolean = false;
  billingAddressDetails:any;
  transactionCountryCode:string;
  transactionType:string;
  environment=environment;
  ZeroDiscountForOptimization: string = ZeroDiscountForOptimization;
  autoApplyCouponcode: boolean = false;
  shippingAddress:any;
  autoAppliedCouponcode:any;
  constructor(
    public SubscriptionService: SubscriptionService,
    public router: Router,
    public spinner: NgxSpinnerService,
    public dialog: MatDialog,
    private zone: NgZone,
    private gaService: GAnalyticsService,
    private fb: FormBuilder,
    private http:HttpClient,
    public razorpayapiService: RazorpayapiService,
    private toastr: ToastrService,
    public markRef: ChangeDetectorRef,
    private userService: UserService,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
  ) { 
    this.navExtra = this.router.getCurrentNavigation()?.extras;
    let _params = { ...(this.activatedRoute.snapshot.queryParams || {}) };
    this.queryParams = { ..._params };
    console.log(this.queryParams);
    this.subscriptionbillingUtility.toi = this.queryParams?.istoi;
    localStorage.setItem('targetExamName', this.queryParams.examName);
    this.isAits = this.queryParams?.isAits;
    this.autoApplyCouponcode = _params?.couponCode ? true : false;
    this.autoAppliedCouponcode = _params?.couponCode ? _params?.couponCode : '';
  }

  ngOnInit(): void {
    this.deviceWidth = window.innerWidth;
    this.isFromBajajFinservAppInApp = sessionStorage.getItem("isFromBajajFinservAppInApp") === "true" ? true : false;
    if (history.state && history.state?.tryagain) {
      this.isTryAgain = history.state?.tryagain;
      var payments = localStorage.getItem(apisDataCacheKeys.payments)
      ? JSON.parse(localStorage.getItem(apisDataCacheKeys.payments))
      : {};
      this.subscriptionbillingUtility.discountCode = payments.discountCode;
      this.subscriptionbillingUtility.selectedPackage =
        payments.selectedPackage;
      this.subscriptionbillingUtility.selectedDuration =
        payments.selectedDuration;
      this.subscriptionbillingUtility.selectedBatch = payments.selectedBatch;
      // this.selectedPartOptions = payments.selectedPartOptions;
      // this.jodoselectedPartOptions = payments.jodoselectedPartOptions;
      const method = history.state?.selectedPaymentData?.method;
      this.isTryAgainMethod = history.state?.selectedPaymentData?.method;
      if(method == "card") {
        this.customPaymntTypeEvent("card");
      } else if(method == "netbanking") {
        this.customPaymntTypeEvent("net_banking");
      } else if(method == "upi") {
        this.customPaymntTypeEvent("upi");
      } else if(method == "wallet") {
        this.customPaymntTypeEvent("wallet");
      } else if(method == "emi" || method == "cardless_emi") {
        this.customPaymntTypeEvent("emi");
      } else if(method == "pay_in_part") {
        this.customPaymntTypeEvent("pay_in_part");
        this.partPaymentTabNo = history.state?.selectedPaymentData?.partPaymentTabNo;
        this.selectedPartOptions =  history.state?.selectedPaymentData?.partPayment;
        this.jodoselectedPartOptions = history.state?.selectedPaymentData?.jodoPartPayment;
      } else if(method == "paylater") {
        this.customPaymntTypeEvent("pay_later");
      } 
      console.log(method);
    }

    let cookieData = getILCookie('INFINITY_LEARN');  
    if(cookieData){
      let data = JSON.parse(cookieData);
      setLoggedInUserData(data, this.userService, this.authService);
      if(data?.scoreData){
        localStorage.setItem('scoreData', JSON.stringify(data?.scoreData));
      }
      setILCookie('INFINITY_LEARN', '', -1);
    }

    this.selectedBatch = JSON.parse(getILCookie('selectedBatch'));
    this.validitySelected = JSON.parse(getILCookie('selectedValidity'));
    this.courseSelected = JSON.parse(getILCookie('courseSelected'));
    this.billingAddress = JSON.parse(getILCookie('billingAddress'));
    this.cartItemId  = JSON.parse(getILCookie('cartItemId'));

    var userData = localStorage.getItem("user_details_from_server") ? JSON.parse(localStorage.getItem("user_details_from_server")): {};

    this.subscriptionbillingUtility.localUserData=userData;
    this.userDetails = userData;
    this.shippingAddress = this.billingAddress?.shippingAddress ? this.billingAddress?.shippingAddress : {};
    this.discountCode = this.billingAddress?.discountCode ? this.billingAddress?.discountCode : "";
    console.log('this.subscriptionbillingUtility?.localUserData?: ', this.subscriptionbillingUtility?.localUserData);
    setTimeout(()=>{
      this.getSelectedCartItem(this.cartItemId);
    },1000)
    var param = {
      examName: this.queryParams?.examName,
      producttype: 'assessment,liveclasses,recordedcourse,hardware,selflearn',
      grade: this.queryParams?.grade,
      pageUrl: this.queryParams?.pageUrl? this.queryParams?.pageUrl : '',
    }
    this.SubscriptionService.totalexamTypePackages(param).subscribe((response:any)=>{
      this.packageDeatails = response.find(element=> element.id == this.queryParams?.id);
      this.pacakgeSelected = this.packageDeatails;
      this.subscriptionbillingUtility.selectedPackage = this.packageDeatails;
      console.log(this.pacakgeSelected);
      localStorage.setItem('packageDetails', JSON.stringify(this.packageDeatails));
  
    console.log('this.subscriptionbillingUtility.selectedPackage: ', this.subscriptionbillingUtility?.selectedPackage);
    if(this.subscriptionbillingUtility?.selectedPackage?.productId != 10){
    this.getExistPackagesOrderDetail(this.subscriptionbillingUtility?.selectedPackage?.id);
    }
    this.subscriptionbillingUtility.isProPlusPackage = this.pacakgeSelected?.productName
      ?.toLowerCase()
      .replace(/\s/g, '') == 'proplus';
    this.subscriptionbillingUtility.liveClassbatch =
    this.subscriptionbillingUtility?.selectedPackage?.packageSubscriptionList?.[0]?.componentsList.filter(
        (val) => val.producType?.toLowerCase() == 'liveclasses'
      );
    console.log(this.subscriptionbillingUtility.liveClassbatch)
    if (this.subscriptionbillingUtility.liveClassbatch?.length > 0) {
      this.subscriptionbillingUtility.selectedBatch = this.selectedBatch;
      this.subscriptionbillingUtility.courseSelected = this.courseSelected; 
      // this.subscriptionbillingUtility.today = new Date(
      //   this.selectedBatch?.startDate
      // );
      // this.showPatialPaymentOptions(
      //   this.subscriptionbillingUtility?.selectedPackage?.id,
      //   this.subscriptionbillingUtility?.selectedPackage
      //     ?.packageSubscriptionList?.[0]?.id
      // );
      this.subscriptionbillingUtility.selectedPackage.isScore = false;
    } else if (
      this.subscriptionbillingUtility.selectedPackage.productName
        .toLowerCase()
        .replace(/\s/g, '') == 'score'
    ) {
      this.subscriptionbillingUtility.selectedPackage.isScore = true;
      // this.showPatialPaymentOptions(
      //   this.subscriptionbillingUtility?.selectedPackage?.id,
      //   this.validitySelected.id
      // );
    } else {
      this.subscriptionbillingUtility.selectedValidity = this.validitySelected;
      // this.showPatialPaymentOptions(
      //   this.subscriptionbillingUtility?.selectedPackage?.id,
      //   this.validitySelected.id
      // );
      this.subscriptionbillingUtility.selectedPackage.isScore = false;
    }
  });
    this.subscriptionbillingUtility.selectedDuration = this.validitySelected;
    this.subscriptionbillingUtility.userDetails = this.userDetails;
    this.subscriptionbillingUtility.userDetails.email = this.billingAddress?.email;
    this.subscriptionbillingUtility.userDetails.pincode = this.billingAddress?.pincode;
    this.subscriptionbillingUtility.userDetails.address = this.billingAddress?.address;

    this.subscriptionbillingUtility.stateName = this.subscriptionbillingUtility.states.find((val) => val.abbreviation == this.billingAddress?.state);
      const userGrade = this.subscriptionbillingUtility?.localUserData?.grade?.name?.replace(/[^0-9]/g,'');
      let cartbody = {
        grade: userGrade,
        userId: this.subscriptionbillingUtility.localUserData?.userId
      }

     if(this.autoApplyCouponcode) {
        console.log('manual');
        this.subscriptionbillingUtility.discountCode = this.autoAppliedCouponcode;
        this.applyDiscountCode(); 
        this.subscriptionbillingUtility.applyCouponHere = true;
      } else {
        console.log('optimal');
        this.applyDiscountCode("optimal"); // Get all Calculation from calculate Discount API with Zero discount
        this.subscriptionbillingUtility.applyCouponHere = false;
        this.autoApplyCouponcode = false;
      }
    //   if (this.discountCode) {
    //     this.subscriptionbillingUtility.discountCode = this.discountCode;
    //     console.log(this.discountCode)
    //     // this.applyDiscountCode();
    //     setTimeout(() => {
    //       this.applyDiscountCode();
    //     }, 100)
    //     this.subscriptionbillingUtility.applyCouponHere = true;
    //   }
    //   if(!this.discountCode){
    //     var promise = new Promise<void>((resolve, reject) => {
    //       setTimeout(() => {
    //   let CartItemId = this.cartItemId;
    //   console.log(CartItemId,"aaa");
    //   this.SubscriptionService.getAllCartItems(cartbody).subscribe((res:any)=>{
    //     let key = res?.find(ele=>ele.id == CartItemId);
    //     this.couponCode = key?.marketingCode[0];
    //     if(this.couponCode){
    //       this.subscriptionbillingUtility.discountCode = this.couponCode;
    //       this.applyDiscountCode();
    //     this.subscriptionbillingUtility.applyCouponHere = true;
    //       this.autoApplyMarketing = true;
    //     }
    //     else{
    //       this.autoApplyMarketing = false;
    //     }
    //   })
    //   resolve();
    // },1000)
    // return promise;
    // });
    //   }
    this.createCardForm();
    // net banking search dropdown
    this.createBankForm();
    this.createUPIForm();
    this.createEMICardForm();
    this.createBajajEMICardForm();

    let rzp = new this.razorpayapiService.nativeWindow['Razorpay']({  
      key: environment.razorkey
    });
    rzp.once('ready', async (response) => {
      console.log(response)
      this.razorPayData = response;
      let bankDetails = response?.methods?.netbanking;
      let bankKeys = [];
      for (const key in bankDetails) {
        if (bankDetails.hasOwnProperty(key)) {
          bankKeys.push({ key });
          this.options.push({ name: bankDetails[key] });
          const index = this.popularBanksList.findIndex((bank) => bank.code==key);
          if(index != -1) {
            this.popularBanks.push(this.popularBanksList[index]);
          }
        }
      }
      this.popularBanks = this.popularBanksList.filter((bank) => bankKeys.findIndex(({ key }) => bank.code==key) != -1);
      let wallet = response?.methods?.wallet;
      for (const key in wallet) {
        if (wallet.hasOwnProperty(key)) {
          this.wallets.push({ name: key, code: key })
        }
      }
      let emi_options = response?.methods?.emi_options;
      this.emi_data = this.getEmiData(emi_options);
      this.checkVaildEmiData();
    })
    this.getIPAddress();
    if(this.deviceWidth > 768){
      this.customPaymntTypeEvent("upi");//?panel closed bug resolved
    }
  }

  getEmiData(emi_options: any) {
    let emi_data = [];
    for (const key in emi_options) {
      if (emi_options.hasOwnProperty(key)) {
        const val = emi_options[key];
        const emiPlan = {
          name: this.getEMIBankNameByCode(key),
          code: key,
          mode:
            key == 'HDFC' || key == 'HSBC'
              ? 'credit'
              : key == 'HDFC_DC'
              ? 'debit'
              : 'all',
          plans: val.map(x => {
            x.min_amount = x.min_amount/100;
            x.code = key;
            return x;
          }),
          isNoCostEMI: val.findIndex(x => x.interest==0)!=-1,
        };
        if(key != "onecard" && emiPlan.name != "None") {
          emi_data.push(emiPlan);
        }
      }
    }
    return emi_data;
  }

  @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.deviceWidth = window.innerWidth;
  }

  getEMIBankNameByCode(code: any) {
    let bankName;
    switch(code) {
      case "AMEX":
        bankName = "American Express";
        break;
      case "BARB":
        bankName = "Bank of Baroda";
        break;
      case "CITI":
        bankName = "CITI Bank";
        break;
      case "HDFC":
        bankName = "HDFC Bank";
        break;
      case "HDFC_DC":
        bankName = "HDFC Bank";
        break;
      case "HSBC":
        bankName = "HSBC Bank";
        break;
      case "ICIC":
        bankName = "ICICI Bank";
        break;
      case "INDB":
        bankName = "Indusind Bank";
        break;
      case "KKBK":
        bankName = "Kotak Mahindra Bank";
        break;
      case "RATN":
        bankName = "RBL Bank";
        break;
      case "SCBL":
        bankName = "Standard Chartered Bank";
        break;
      case "UTIB":
        bankName = "Axis Bank";
        break;
      case "YESB":
        bankName = "Yes Bank";
        break;
      default:
        bankName = "None";
        break;
    }
    return bankName;
  }

  payUsingRazorPayCustomWebSDK(subscriptionbillingUtility, selectedPaymentData) {
    console.log(subscriptionbillingUtility)
    console.log(selectedPaymentData)
    let finalazorpayAmount =
      this.subscriptionbillingUtility.payValue == 'fullpayment'
        ? this.customPaymntType == 'emi' || this.customPaymntType == 'pay_later'
          ? Math.round(
              (this.subscriptionbillingUtility?.emiPayLaterFulltotalAmount +
                Number.EPSILON) *
                100
            )
          : Math.round(
              (this.subscriptionbillingUtility?.fullPaymentOptions?.amount +
                Number.EPSILON) *
                100
            )
        : Math.round(((this.jodoProductType === "FLEX" ? this.subscriptionbillingUtility?.jodoemiOptions?.[0]?.amount:this.subscriptionbillingUtility?.emiOptions?.[0]?.amount) + Number.EPSILON) * 100);
    var paymentData = {
      amount: finalazorpayAmount, //pass in paise (amount: 100000 equals ₹1000)
      email: subscriptionbillingUtility.userDetails?.email || '', 
      contact: subscriptionbillingUtility.userDetails?.phone ,
      "order_id": subscriptionbillingUtility.generatedOrderDetails.gatewayOrderId,
      description: 'Subscription',
      ...selectedPaymentData,
    };
    console.log(paymentData);
    const options = {
      name: this.subscriptionbillingUtility.userDetails.firstName + ' ' + this.subscriptionbillingUtility.userDetails.lastName,
      amount: 100, // razorpay takes amount in paisa
      prefill: {
        name: this.subscriptionbillingUtility.userDetails?.firstName + ' ' + this.subscriptionbillingUtility.userDetails?.lastName,
        email: this.subscriptionbillingUtility.userDetails?.email || '', // add your email id
        contact: this.subscriptionbillingUtility.userDetails?.phone 
      },
    };
    let rzp = new this.razorpayapiService.nativeWindow['Razorpay']({  key: environment.razorkey });
    rzp.createPayment(paymentData)
    .on('payment.success', (response) => {
      this.paymentHandler(subscriptionbillingUtility, response, options);
    })
    .on('payment.error', (err) => {
      console.log(err);
      if(this.subscriptionbillingUtility.payValue ==  'fullpayment') {
        subscriptionbillingUtility.selectedPaymentData = {...selectedPaymentData};
      } else {
        subscriptionbillingUtility.selectedPaymentData = {...selectedPaymentData, method: "pay_in_part", partPayment: this.subscriptionbillingUtility?.emiOptions, partPaymentTabNo: 1};
      }
      subscriptionbillingUtility.error = err?.error;
      this.onPaymentFailure(subscriptionbillingUtility,options);
      this.spinner.hide();
    })
    if(rzp?._payment?.popup == null) {
      this.spinner.hide();
    }
  }


  showPatialPaymentOptions(PackageId?, durationId?, couponCodeData?) {
    console.log(couponCodeData,'couponCodeData')
    let body = {
      subscriptionId: durationId
    }
    this.subscriptionbillingUtility.partialPayment = [];
    this.subscriptionbillingUtility.jodoflexpartialPayment = [];
    this.subscriptionbillingUtility.freeProPackageAmount = couponCodeData?.specialDisAmount;
    couponCodeData?.partPaymentPlanMasterDtoList?.forEach((ele)=>{
      if (ele.partPaymentPlanDetailsDto.length == 1) {
        this.subscriptionbillingUtility.fullPayment = ele;
      } else {
        this.subscriptionbillingUtility.partialPayment.push(ele);
      }
      this.subscriptionbillingUtility.partialPayment.sort((a, b) => {
        return (
          a.partPaymentPlanDetailsDto.length -
          b.partPaymentPlanDetailsDto.length
        );
      });

      // this.calculateEmioptions();
    });
    couponCodeData?.jodoPartPaymentPlanMasterDtoList?.forEach((ele)=>{
      if (ele.partPaymentPlanDetailsDto.length == 1) {
        // this.subscriptionbillingUtility.fullPayment = ele;
      } else {
        this.subscriptionbillingUtility.jodoflexpartialPayment.push(ele);
      }
      this.subscriptionbillingUtility.jodoflexpartialPayment.sort((a, b) => {
        return (
          a.partPaymentPlanDetailsDto.length -
          b.partPaymentPlanDetailsDto.length
        );
      });

      // this.calculateEmioptions();
    });
    this.calculateEmioptions();
    // this.SubscriptionService.getAllPaymentInfo(body).subscribe((res: any) => {
    //   res?.forEach((element, index) => {

    //   // remove part payment 3 in production
    //   // const tenantFromUrl = localStorage.getItem('tenantFromUrl'); 
    //   // if(!tenantFromUrl){
    //   //   let partPaymentIndex = -1;
    //   //   res.forEach(elementPartPayment => {
    //   //     ++partPaymentIndex;
    //   //     if(elementPartPayment.name == "3 Parts Payment"){
    //   //       res.splice(partPaymentIndex,1);
    //   //     }
    //   //   });
    //   // }
   
    //   // end here
    //   element?.partPaymentPlanMasterDtoList?.forEach((ele)=>{
    //     if (ele.partPaymentPlanDetailsDto.length == 1) {
    //       this.subscriptionbillingUtility.fullPayment = ele;
    //     } else {
    //       this.subscriptionbillingUtility.partialPayment.push(ele);
    //     }
    //     this.subscriptionbillingUtility.partialPayment.sort((a, b) => {
    //       return (
    //         a.partPaymentPlanDetailsDto.length -
    //         b.partPaymentPlanDetailsDto.length
    //       );
    //     });
  
    //     this.calculateEmioptions();
    //   });
    //   element?.jodoPartPaymentPlanMasterDtoList?.forEach((ele)=>{
    //     if (ele.partPaymentPlanDetailsDto.length == 1) {
    //       // this.subscriptionbillingUtility.fullPayment = ele;
    //     } else {
    //       this.subscriptionbillingUtility.jodoflexpartialPayment.push(ele);
    //     }
    //     this.subscriptionbillingUtility.jodoflexpartialPayment.sort((a, b) => {
    //       return (
    //         a.partPaymentPlanDetailsDto.length -
    //         b.partPaymentPlanDetailsDto.length
    //       );
    //     });
  
    //     this.calculateEmioptions();
    //   });
    //   })
    // }),
    //   (error) => { };
    //   if(this.subscriptionbillingUtility?.selectedPackage?.productId==10){
    //     this.checkForBooksPackage();
    //   }
  }

  applyDiscountCode(type?:any) {
    this.spinner.show();

    let userDetails = this.SubscriptionService?.getuserDetails();
    let discode2 = {
      code: type == "optimal" ? this.ZeroDiscountForOptimization : this.subscriptionbillingUtility.discountCode,
      grade: this.subscriptionbillingUtility.localUserData?.grade?.name?.replace(/[^0-9]/g, '') || userDetails?.grade?.name?.replace(/[^0-9]/g, ''),
      userId: this.subscriptionbillingUtility.localUserData?.userId || userDetails?.userId
    };
    let CartItemId = this.cartItemId;
    if (this.subscriptionbillingUtility.discountCode || type == "optimal") {
      this.SubscriptionService.calulateDiscountForCartItemUsingGET(discode2).subscribe(
        (resp: any) => {
          resp?.discountForSubcriptionDtoList?.forEach((v) => {
            if(v?.jodoPartPaymentPlanMasterDtoList?.length == 0) {
              v.jodoPartPaymentPlanMasterDtoList = v?.partPaymentPlanMasterDtoList?.filter((plan: any) => plan?.name == "Full Payment");
            } else if(v?.jodoPartPaymentPlanMasterDtoList?.findIndex((plan: any) => plan?.name == "Full Payment") == -1) {
              v.jodoPartPaymentPlanMasterDtoList.push(v?.partPaymentPlanMasterDtoList?.find((plan: any) => plan?.name == "Full Payment"))
            }
            v.subcription = v.subscription;
            ['partPaymentPlanMasterDtoList','jodoPartPaymentPlanMasterDtoList'].forEach((key)=>{
              v[key].forEach((installmentList) => {
                installmentList?.partPaymentPlanDetailsDto?.forEach((patPlan, index, self) => {
                    let nextDate = moment();
                    if(this.subscriptionbillingUtility?.selectedBatch?.startDate){
                      let batchstart_unixdate =moment(this.subscriptionbillingUtility?.selectedBatch?.startDate); 
                      nextDate=  moment().isBefore( batchstart_unixdate) ? batchstart_unixdate: nextDate;
                    }
                    patPlan.lastdate = nextDate.add(patPlan.daysLimit, 'days').set("hour", 23).set('minute', 59).format('YYYY-MM-DD HH:mm:ss');        
                    patPlan.applicableAmount = Number(patPlan?.amount.toFixed(2));
                  // patPlan.amount =  index ?  0 :patPlan.amount
                  if(key == 'jodoPartPaymentPlanMasterDtoList' && index == self?.length-1 && index != 0) { // for flex last part payment
                    const totalAmountOfPartPlans = self?.reduce((a, b) => a+b?.applicableAmount, 0);
                    const diff = totalAmountOfPartPlans - v?.afterDiscountAmount; // afterDiscountAmount is after removing coupon discount, books packages discount amount
                    patPlan.applicableAmount -= diff;
                  }
                })
              });
            })
          console.log(resp.discountForSubcriptionDtoList);

          });
          if (resp) {
            let amount = resp?.discountForSubcriptionDtoList?.find(element=>element.id == CartItemId);
            this.subscriptionbillingUtility.discountAmount =
            amount?.discountValue;
            let response = resp?.discountForSubcriptionDtoList?.find(element=>element.id == CartItemId);
            this.showPatialPaymentOptions(0,0,response);
            if(type !== "optimal") {
              this.subscriptionbillingUtility.applyCouponHere = true;
              this.subscriptionbillingUtility.discountValid = 'valid';
            }
            if(this.autoApplyMarketing){
              this.callAutoApplyCouponActionPopup(amount?.discountValue);
            }
            
            // this.subscriptionbillingUtility.discountValid = 'valid';
            var payments = localStorage.getItem(apisDataCacheKeys.payments)
              ? JSON.parse(localStorage.getItem(apisDataCacheKeys.payments))
              : {};
            payments.discountCode = discode2.code;
            localStorage.setItem(apisDataCacheKeys.payments, JSON.stringify(payments));
            // this.calculateEmioptions();
            if(this.customPaymntType == "emi") {
              this.checkVaildEmiData();
            }
            if(this.customPaymntType == "pay_later") {
              this.checkSimpleEligibility("check_eligibility");
            }
            this.spinner.hide();
          } else {
            this.spinner.hide();
            this.subscriptionbillingUtility.discountValid = 'error';
            this.subscriptionbillingUtility.discountCode = null;
          }
        },
        (err) => { 
          this.spinner.hide()
          this.subscriptionbillingUtility.applyCouponHere = true;
          this.subscriptionbillingUtility.discountValid = 'error';
        }
      );
    }
    // let discode = {
    //   code: this.subscriptionbillingUtility.discountCode,
    //   totalAmount: (this.subscriptionbillingUtility.liveClassbatch?.length > 0) ? (this.subscriptionbillingUtility.selectedPackage.packageSubscriptionList[0]?.amount) : this.subscriptionbillingUtility.selectedDuration?.amount,
    // };
    // if (this.subscriptionbillingUtility.discountCode) {
    //   this.SubscriptionService.validateDiscountCode(discode).subscribe(
    //     (resp: any) => {
    //       if (resp?.validDiscountCode) {
    //         this.subscriptionbillingUtility.discountAmount =
    //           resp?.discountAmount;
    //         this.subscriptionbillingUtility.discountValid = 'valid';
    //         var payments = localStorage.getItem(apisDataCacheKeys.payments)
    //           ? JSON.parse(localStorage.getItem(apisDataCacheKeys.payments))
    //           : {};
    //         payments.discountCode = discode.code;
    //         localStorage.setItem(apisDataCacheKeys.payments, JSON.stringify(payments));
    //         this.calculateEmioptions();
    //         if(this.customPaymntType == "emi") {
    //           this.checkVaildEmiData();
    //         }
    //         if(this.customPaymntType == "pay_later") {
    //           this.checkSimpleEligibility("check_eligibility");
    //         }
    //         this.spinner.hide();
    //       } else {
    //         this.subscriptionbillingUtility.discountValid = 'error';
    //         this.subscriptionbillingUtility.discountCode = null;
            
    //         this.spinner.hide();
    //       }
    //     },
    //     (err) => { }
    //   );
    // }
  }

  callAutoApplyCouponActionPopup(couponAmount) {
    this.toastr.info(`Congratulations! Rs. ${couponAmount} added to your account`, "", {
      tapToDismiss: false,
      timeOut: 5000,
      closeButton: true,
    });
  }



  calculateEmioptions() {
    this.subscriptionbillingUtility.emiOptions = [];
    // this.subscriptionbillingUtility.partialPayment.forEach(
    //   (partpaymentarray, indexval) => {
    //     let allEmiOptions = [];
    //     partpaymentarray?.partPaymentPlanDetailsDto?.forEach(
    //       (element, index, self) => {
    //         if (index !== 0) {
    //           element.amount =
    //           ((((this.subscriptionbillingUtility.liveClassbatch?.length > 0 ? this.subscriptionbillingUtility.selectedPackage.packageSubscriptionList[0]?.amount : this.subscriptionbillingUtility.selectedDuration?.amount) -
    //             this.subscriptionbillingUtility?.discountAmount) - (this.subscriptionbillingUtility?.freeProPackageAmount) - self?.[0]?.amount) * element?.percentage) / 100;
    //         }
    //         partpaymentarray.emiOptions = [];
    //         // element.lastdate = new Date(this.subscriptionbillingUtility.today);
    //         // element.lastdate.setDate(
    //         //   element.lastdate.getDate() + element?.daysLimit
    //         // );
    //         let nextDate = moment();
    //         let batchStartDate = moment(this.subscriptionbillingUtility?.selectedBatch?.startDate);
    //         nextDate = moment().isBefore( batchStartDate) ? batchStartDate: nextDate;
    //         element.lastdate = nextDate.add(element?.daysLimit, 'days').set("hour", 23).set('minute', 59).format('YYYY-MM-DD HH:mm:ss');
    //         allEmiOptions.push({ ...element });
    //       }
    //     );
    //     partpaymentarray.emiOptions = allEmiOptions;
    //   }
    // );
    // jodopartpayments
    this.subscriptionbillingUtility.jodoemiOptions = [];
    // this.subscriptionbillingUtility.jodoflexpartialPayment.forEach(
    //   (partpaymentarray, indexval) => {
    //     let jodoallEmiOptions = [];
    //     partpaymentarray?.partPaymentPlanDetailsDto?.forEach(
    //       (element, index, self) => {
    //         if (index !== 0) {
    //           element.amount =
    //             ((((this.subscriptionbillingUtility.liveClassbatch?.length > 0 ? this.subscriptionbillingUtility.selectedPackage.packageSubscriptionList[0]?.amount : this.subscriptionbillingUtility.selectedDuration?.amount) -
    //             this.subscriptionbillingUtility?.discountAmount) - (this.subscriptionbillingUtility?.freeProPackageAmount) - self?.[0]?.amount) * element?.percentage) / 100;
    //         }
    //         partpaymentarray.jodoemiOptions = [];
    //         // element.lastdate = new Date(this.subscriptionbillingUtility.today);
    //         // element.lastdate.setDate(
    //         //   element.lastdate.getDate() + element?.daysLimit
    //         // );
    //         let nextDate = moment();
    //         let batchStartDate = moment(this.subscriptionbillingUtility?.selectedBatch?.startDate);
    //         nextDate = moment().isBefore( batchStartDate) ? batchStartDate: nextDate;
    //         element.lastdate = nextDate.add(element?.daysLimit, 'days').set("hour", 23).set('minute', 59).format('YYYY-MM-DD HH:mm:ss');
    //         jodoallEmiOptions.push({ ...element });
    //       }
    //     );
    //     partpaymentarray.jodoemiOptions = jodoallEmiOptions;
    //   }
    // );
    // this.selectedEmiInstalments(this.subscriptionbillingUtility?.partialPayment?.[0]);
    // this.jodoFlexselectedEmiInstalments(this.subscriptionbillingUtility?.jodoflexpartialPayment?.[0]);
    if(this.selectedPartOptions){
    let partOptions =  this.subscriptionbillingUtility?.partialPayment?.find(element=>element.name == this.selectedPartOptions?.name);
    this.selectedEmiInstalments(partOptions);
    } else {
      this.selectedEmiInstalments(this.subscriptionbillingUtility?.partialPayment?.[0]);
    } 
    if(this.jodoselectedPartOptions){
      let partOptions =  this.subscriptionbillingUtility?.jodoflexpartialPayment?.find(element=>element.name == this.jodoselectedPartOptions?.name);
      this.jodoFlexselectedEmiInstalments(partOptions);
      } else {
        this.jodoFlexselectedEmiInstalments(this.subscriptionbillingUtility?.jodoflexpartialPayment?.[0]);
      } 
    console.log(this.subscriptionbillingUtility)
    let pfullpayment = this.subscriptionbillingUtility.fullPayment?.partPaymentPlanDetailsDto?.[0];
    console.log(pfullpayment,'pfullpayment')
    // let pfullpayment =
    //   this.subscriptionbillingUtility.fullPayment
    //     ?.partPaymentPlanDetailsDto?.[0];
    //     var fullamount =
    //     (((this.subscriptionbillingUtility.liveClassbatch?.length > 0 ? this.subscriptionbillingUtility.selectedPackage.packageSubscriptionList[0]?.amount : this.subscriptionbillingUtility.selectedDuration?.amount) -
    //       this.subscriptionbillingUtility?.discountAmount) - this.subscriptionbillingUtility?.freeProPackageAmount)*
    //     ((100 - pfullpayment?.discountPer) / 100);
    // console.log('fullamoun: ', fullamount);

    var fullamount = pfullpayment?.amount* ((100 - pfullpayment?.discountPer) / 100);

    // let fullamountwithout = (this.subscriptionbillingUtility.liveClassbatch?.length > 0 ? this.subscriptionbillingUtility.selectedPackage.packageSubscriptionList[0]?.amount : this.subscriptionbillingUtility.selectedDuration?.amount);
    // this.subscriptionbillingUtility.emiPayLaterFulltotalAmount = ((fullamountwithout) - (this.subscriptionbillingUtility?.discountAmount)) -(this.subscriptionbillingUtility?.freeProPackageAmount);
    this.subscriptionbillingUtility.emiPayLaterFulltotalAmount = pfullpayment?.amount;
    console.log(this.subscriptionbillingUtility?.emiPayLaterFulltotalAmount);
    if(!this.subscriptionbillingUtility?.emiPayLaterFulltotalAmount && (this.customPaymntType=="emi" || this.customPaymntType == "pay_in_part" || this.customPaymntType == "pay_later" || this.paymentType == 'partpayment')){
      this.paymentType = "fullpayment";
      this.customPaymntTypeEvent("card");
    }
    if(this.customPaymntType == "pay_later") {
      this.checkSimpleEligibility("check_eligibility");
    }

    this.subscriptionbillingUtility.fullPaymentOptions = {
      ...pfullpayment,
      amount: fullamount,
    };
    console.log('this.subscriptionbillingUtility.fullPaymentOptions: ', this.subscriptionbillingUtility.fullPaymentOptions);

    console.log(this.subscriptionbillingUtility)
  }

  selectedEmiInstalments(selectedpartPaymentoption) {
    if(this.selectedPartOptions?.length && this.isTryAgain){
      this.subscriptionbillingUtility.emiOptions = this.selectedPartOptions;
    } else {
      this.selectedPartOptions = [];
      this.subscriptionbillingUtility.emiOptions = selectedpartPaymentoption?.partPaymentPlanDetailsDto;
      this.selectedPartOptions = selectedpartPaymentoption;
    }
      var payments = localStorage.getItem(apisDataCacheKeys.payments) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.payments)) : {};
      payments.selectedPartOptions = selectedpartPaymentoption;
      localStorage.setItem(apisDataCacheKeys.payments, JSON.stringify(payments));
  }

  jodoFlexselectedEmiInstalments(selectedpartPaymentoption){
    if(this.jodoselectedPartOptions?.length && this.isTryAgain){
      this.subscriptionbillingUtility.jodoemiOptions = this.jodoselectedPartOptions;
    } else{
      this.jodoselectedPartOptions = [];
      this.subscriptionbillingUtility.jodoemiOptions = selectedpartPaymentoption?.partPaymentPlanDetailsDto;
      this.jodoselectedPartOptions = selectedpartPaymentoption;
    }
    setTimeout(()=>{
      this.subscriptionbillingUtility?.jodoemiOptions?.forEach((patPlan, index, self) => {
        patPlan.amount = Number(patPlan.amount.toFixed(2))
        console.log(patPlan?.amount)
        if(index == self?.length-1 && index != 0) {
          const totalAmountOfPartPlans = self?.reduce((a, b) => a+b?.amount, 0);
          const diff = totalAmountOfPartPlans - this.subscriptionbillingUtility.emiPayLaterFulltotalAmount;
          patPlan.amount -= diff;
        }
      },500);
    })
    console.log(this.subscriptionbillingUtility.jodoemiOptions,'reduce emioptions')
      var payments = localStorage.getItem(apisDataCacheKeys.payments) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.payments)) : {};
      payments.JodoselectedPartOptions = selectedpartPaymentoption;
      localStorage.setItem(apisDataCacheKeys.payments, JSON.stringify(payments));
  }

  removeAppliedCode() {
    this.spinner.show();
    this.subscriptionbillingUtility.discountValid = '';
    this.subscriptionbillingUtility.discountAmount = 0;
    this.subscriptionbillingUtility.discountCode = '';
    this.autoApplyMarketing = false;
    var payments = localStorage.getItem(apisDataCacheKeys.payments) ? JSON.parse(localStorage.getItem(apisDataCacheKeys.payments)) : {};
    payments.discountCode = '';
    localStorage.setItem(apisDataCacheKeys.payments, JSON.stringify(payments));
    this.applyDiscountCode("optimal");
    // this.calculateEmioptions();
    if(this.customPaymntType == "emi") {
      this.checkVaildEmiData();
    }
    if(this.customPaymntType == "pay_later") {
      this.checkSimpleEligibility("check_eligibility");
    }
    setTimeout(() => {
      this.spinner.hide()//intended spinner to add user good expeience
    }, 500)
  }

  blockStudentEnrollmentinliveClass() {
    var body = {
      student: this.subscriptionbillingUtility?.localUserData?.userId?.toString(),
      course: this.subscriptionbillingUtility?.courseSelected?.id,
      batch: this.subscriptionbillingUtility?.selectedBatch?.id,
    };
    console.log(body);
    this.spinner.show();
    this.SubscriptionService.blockCourseEnrollment(body).subscribe(
      
      (resp: any) => {
        console.log(resp)
        if (resp?.statusCode == 201) {
          this.spinner.hide();
          this.razorPayWindow();
        }
      },
      (err) => {
        this.spinner.hide();
        if (err?.status == 400) {
          let dialogRef = this.dialog.open(
            TestRegistrationConfirmDialogComponent,
            {
              height: '280px',
              width: '500px',
              data: {
                message1: 'Oops!',
                message2: err?.error?.message,
              },
            }
          );
        }
      }
    );
  }

  payValue(amount, type) {
    console.log(amount);
    this.paymentValue = amount; //get payment value for button
    this.subscriptionbillingUtility.payValue = type;
    this.subscriptionbillingUtility.paidOptions = [];
    console.log(amount,type);
    console.log(this.subscriptionbillingUtility)
    if (type == 'fullpayment') {
      let fultimeDate = new Date().setHours(23, 59, 59, 999);
      this.subscriptionbillingUtility.paidOptions = [
        {
          paidAmount:
          this.customPaymntType == 'emi' || this.customPaymntType == 'pay_later' ? 
          this.subscriptionbillingUtility?.emiPayLaterFulltotalAmount
          : this.subscriptionbillingUtility?.fullPaymentOptions?.amount?.toFixed(2),
          applicableAmount:
          this.customPaymntType == 'emi' || this.customPaymntType == 'pay_later' ? 
          this.subscriptionbillingUtility?.emiPayLaterFulltotalAmount
          : this.subscriptionbillingUtility?.fullPaymentOptions?.amount?.toFixed(2),
          partPlanDetailsId:
            this.subscriptionbillingUtility?.fullPaymentOptions?.planDetailId,
          dueDate: moment(fultimeDate).format('YYYY-MM-DD HH:mm:ss'),
          planName: this.subscriptionbillingUtility?.fullPaymentOptions?.name,
        },
      ];
      //for web Events
      this.gaService.webEngageEvent({
        event: 'Payment Type',
        Full_Payment: type,
        amount: amount,
      })
    } else if(type ==='partpayment' && this.jodoProductType === "FLEX") {
      this.subscriptionbillingUtility.jodoemiOptions.forEach((element, index) => {
        let fultimeDate = new Date(element.lastdate).setHours(23, 59, 59, 999);
        this.subscriptionbillingUtility.paidOptions.push({
          paidAmount: (index == 0 ? element.amount : 0).toFixed(2),
          applicableAmount: (element?.amount).toFixed(2),
          partPlanDetailsId: element.planDetailId,
          dueDate: moment(fultimeDate).format('YYYY-MM-DD hh:mm:ss'),
          planName: element.name,
        });
      });
      //for web Events
      this.gaService.webEngageEvent({
        event: 'Payment Type',
        Part_Payment: type,
        Parts: this.subscriptionbillingUtility?.paidOptions?.length,
        amount: amount,
      })
    } else  {
      this.subscriptionbillingUtility.emiOptions.forEach((element, index) => {
        let fultimeDate = new Date(element.lastdate).setHours(23, 59, 59, 999);
        this.subscriptionbillingUtility.paidOptions.push({
          paidAmount: (index == 0 ? element.amount : 0).toFixed(2),
          applicableAmount: (element?.amount).toFixed(2),
          partPlanDetailsId: element.planDetailId,
          dueDate: moment(fultimeDate).format('YYYY-MM-DD hh:mm:ss'),
          planName: element.name,
        });
      });
      //for web Events
      this.gaService.webEngageEvent({
        event: 'Payment Type',
        Part_Payment: type,
        Parts: this.subscriptionbillingUtility?.paidOptions?.length,
        amount: amount,
      })
    }
    console.log(this.subscriptionbillingUtility.selectedBatch?.id);
    if (this.subscriptionbillingUtility.liveClassbatch?.length > 0) {
      console.log('blockstudent');
      this.blockStudentEnrollmentinliveClass();
    } else if (this.subscriptionbillingUtility.paidOptions?.length) {
      console.log('razpay');
      // this.checkSubscription();
      this.razorPayWindow();
    } else {
    }
    // if (this.subscriptionbillingUtility.paidOptions?.length) {
    //   this.razorPayWindow();
    // }
  }
  checkSubscription() {
    var userDetails = localStorage.getItem(apisDataCacheKeys.userDetails)
      ? JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails))
      : {};
    this.spinner.show();
    this.SubscriptionService.getPackagesSubscriptionByUserID({
      subscription_id: this.subscriptionbillingUtility?.selectedValidity?.id || this.subscriptionbillingUtility?.selectedDuration?.id,
      user_id: userDetails?.userId,
    }).subscribe((resp: any) => {
      this.spinner.hide();
      if (resp) {
        let dialogRef = this.dialog.open(
          TestRegistrationConfirmDialogComponent,
          {
            height: '280px',
            width: '500px',
            data: {
              message1: 'Oops!',
              message2:
                'You are already enrolled to this package',
            },
          }
        );
      } else {
        this.spinner.hide();
        this.razorPayWindow();
      }
    });
  }

  razorPayWindow() {
    this.spinner.show();
    let user: any = localStorage.getItem(apisDataCacheKeys.userDetails);
    user = localStorage.getItem(apisDataCacheKeys.userDetails)
      ? JSON.parse(user)
      : {};
    //?shippin details
    // let shippinDetails=JSON.parse(localStorage.getItem('shipping_details'));
    let shippingStateName = this.subscriptionbillingUtility?.states?.find(
      (val) =>
        val.abbreviation == this.shippingAddress?.shipStateCode
    );
      var finalazorpayAmount =
      this.subscriptionbillingUtility.payValue == 'fullpayment'
        ? this.customPaymntType == 'emi' || this.customPaymntType == 'pay_later'
          ? Math.round(
              (this.subscriptionbillingUtility?.emiPayLaterFulltotalAmount +
                Number.EPSILON) *
                100
            ) / 100
          : Math.round(
              (this.subscriptionbillingUtility?.fullPaymentOptions?.amount +
                Number.EPSILON) *
                100
            ) / 100
        : Math.round(((this.jodoProductType === "FLEX" ? this.subscriptionbillingUtility?.jodoemiOptions?.[0]?.amount:this.subscriptionbillingUtility?.emiOptions?.[0]?.amount) + Number.EPSILON) * 100) / 100;
      let payConditionDiscountAmount = 
      this.subscriptionbillingUtility.payValue == 'fullpayment' && this.customPaymntType != 'emi' && this.customPaymntType != 'pay_later'
            ? (this.subscriptionbillingUtility?.selectedDuration?.amount -
                this.subscriptionbillingUtility.discountAmount) *
              (this.subscriptionbillingUtility?.fullPaymentOptions?.discountPer /
                100)
            : (this.subscriptionbillingUtility.selectedDuration?.amount -
                this.subscriptionbillingUtility.discountAmount) *
              (this.subscriptionbillingUtility?.emiOptions?.[0]?.discountPer /
                100) || 0;


      var object: any = {
        amountAfterDiscount: 
        this.subscriptionbillingUtility?.payValue =='partpayment' ? this.subscriptionbillingUtility?.emiPayLaterFulltotalAmount : finalazorpayAmount,
        totalPaidAmount: finalazorpayAmount,
        batchId: this.subscriptionbillingUtility?.selectedBatch?.id ?? '',
        billingAddress: {
          address: this.subscriptionbillingUtility.userDetails?.address ?? '',
          email: this.subscriptionbillingUtility.userDetails.email ?? '',
          firstName: this.subscriptionbillingUtility.userDetails.firstName ?? '',
          lastName: this.subscriptionbillingUtility.userDetails.lastName ?? '',
          phone: this.subscriptionbillingUtility?.userDetails?.phone ?? '',
          statecode: this.subscriptionbillingUtility.stateName.abbreviation ?? '',
          zipcode: this.subscriptionbillingUtility?.userDetails?.pincode ?? '',
          stateName: this.subscriptionbillingUtility?.stateName?.name,
          shipAddress: this.shippingAddress?.shipAddress?this.shippingAddress?.shipAddress:"",
          shipEmail: this.shippingAddress?.shipEmail?this.shippingAddress?.shipEmail:"",
          shipFirstName: this.shippingAddress?.shipFirstName?this.shippingAddress?.shipFirstName:"",
          shipLastName: this.shippingAddress?.shipLastName?this.shippingAddress?.shipLastName:"",
          shipPhone: this.shippingAddress?.shipPhone?this.shippingAddress?.shipPhone:"",
          shipStateCode:this.shippingAddress?.shipStateCode?this.shippingAddress?.shipStateCode:"",
          shipStateName: shippingStateName?.name?shippingStateName?.name:"",
          shipZipCode: this.shippingAddress?.shipZipCode?this.shippingAddress?.shipZipCode:"",
          shipCity: this.shippingAddress?.shipCity?this.shippingAddress?.shipCity: "",
          transactionCountryCode: this.transactionCountryCode? this.transactionCountryCode : null,
        },
        discountAmount: this.subscriptionbillingUtility?.discountAmount,
        discountCode: this.subscriptionbillingUtility.discountCode && this.subscriptionbillingUtility.discountValid == 'valid'
          ? this.subscriptionbillingUtility.discountCode
          : null,
        notes: '',
        orderAmount: (this.subscriptionbillingUtility.selectedDuration?.amount).toFixed(2),
        packageSubscriptions: [
          {
            id: this.subscriptionbillingUtility?.selectedDuration?.id
              ? this.subscriptionbillingUtility?.selectedDuration?.id
              : this.subscriptionbillingUtility?.selectedPackage
                  ?.packageSubscriptionList?.length == 1
              ? this.subscriptionbillingUtility?.selectedPackage
                  ?.packageSubscriptionList?.[0]?.id
              : '',
            paymentPlanCaptureDetailsDtoList:
              this.subscriptionbillingUtility.paidOptions,
            packageDealPriceAfterDiscount: 
            this.subscriptionbillingUtility?.payValue =='partpayment' ? this.subscriptionbillingUtility?.emiPayLaterFulltotalAmount : finalazorpayAmount,
            actual_amount: this.subscriptionbillingUtility.selectedDuration?.amount
            ,
            package_discount_code: this.subscriptionbillingUtility.discountCode && this.subscriptionbillingUtility.discountValid == 'valid'
            ? this.subscriptionbillingUtility.discountCode
            : null,
            package_discount_amount: (Math.round((this.subscriptionbillingUtility?.discountAmount + Number.EPSILON) * 100) / 100) + Math.round(payConditionDiscountAmount) || "",
            quantity: 1,
            courseId: this.subscriptionbillingUtility?.courseSelected?.id,
            batchId: this.subscriptionbillingUtility?.selectedBatch?.id,
            scoreId: null,
            recordedCourse: this.selectedCartItem?.recordedCourse,
            recordedCourseList: this.selectedCartItem?.recordedCourseList || [],
            "specialDiscAmt": this.subscriptionbillingUtility?.freeProPackageAmount||0,
            "specialDiscPer": 0,
          },        
        ],
        isdCode: user?.isdCode ?? '',
        phone: this.subscriptionbillingUtility?.userDetails?.phone ?? '',
        userPhoneNo: user?.phone ?? '',
        payConditionDiscountAmount: Math.round(payConditionDiscountAmount),
        payConditionDiscountper:
          this.subscriptionbillingUtility.payValue == 'fullpayment' &&
          this.customPaymntType != 'emi' &&
          this.customPaymntType != 'pay_later'
            ? this.subscriptionbillingUtility?.fullPaymentOptions?.discountPer
            : this.subscriptionbillingUtility?.emiOptions?.[0]?.discountPer,
        paymentGatewayCode: this.paymentGatewayCode,
        userId: user?.userId,
        userOrderMasterId: 0,
        userOrderPaymentPlanCaptureDetailsId: 0,
        quantity: 1,
        unitPrice: finalazorpayAmount,
        renewed:
          this.subscriptionbillingUtility.selectedPackage?.renewed ?? false,
        extOrderId:
          this.subscriptionbillingUtility.selectedPackage?.extOrderId ?? 0,
        extDays: this.subscriptionbillingUtility.selectedPackage?.extDays ?? 0,
        grade: Number(localStorage.getItem('grade')),
        token: this.simplEligibilityData?.token,
        modeofPayment:
        this.customPaymntType === 'net_banking'
          ? 'netbanking'
          : this.customPaymntType === 'pay_later'
          ? 'paylater'
          : this.customPaymntType,
        emiPatner:
        this.customPaymntType === 'emi'
          ? this.paymentGatewayCode == 'JODO'?'JODO':this.paymentGatewayCode == 'SHOPSE' ? 'SHOPSE' : this.selected_bank_emi_data?.name
          : "",
        installmentAmount: this.customPaymntType === 'emi' ? this.selectedEmiPlan?.amountForMonth?.toFixed(2) : 0,
        transactionAmount: this.customPaymntType === 'emi' ? this.selectedEmiPlan?.amountForMonth.toFixed(2)*this.selectedEmiPlan?.duration : 0,
        transactionType: this.transactionType? this.transactionType : null,
        noOfMonth: this.customPaymntType === 'emi' ? this.selectedEmiPlan?.duration : "",
        payLatterPatner:
            this.customPaymntType === 'pay_later'
              ? this.paymentGatewayCode == 'RAZORPAY'
                ? this.selectedPaylaterMethod
                : 'SIMPL'
              : "",
        cardNo: 
          this.bajajFinanceNoCostEmiData?.showBajaj
            ? this.customPaymntType === 'emi'
              ? this.selctedBajajEMICardData?.cardNo
              : ''
            : undefined,
        bajajMobileNo:
          this.bajajFinanceNoCostEmiData?.showBajaj
            ? this.customPaymntType === 'emi'
              ? this.selctedBajajEMICardData?.phone
              : ''
            : undefined,
        tanure:
          this.bajajFinanceNoCostEmiData?.showBajaj
            ? this.customPaymntType === 'emi'
              ? this.selectedEmiPlan?.duration?.toString()
              : ''
            : undefined,
        ipAdd: this.bajajFinanceNoCostEmiData?.showBajaj ? this.ipAddress : undefined,
        schemeId: this.selectedEmiPlan?.schemeId,
        jodoProductType: this.paymentGatewayCode == "JODO" ? this.jodoProductType : undefined,
        judoFlexPlan: this.paymentGatewayCode == "JODO" && this.jodoProductType=="FLEX" ?{
          payment_schedule: this.subscriptionbillingUtility.jodo_payment_schedule
        } : undefined,
        redirectionUrl: `${window.origin}/subscription/orderprocessing`,
        "specialDiscAmt": this.subscriptionbillingUtility.freeProPackageAmount,
        "specialDiscPer": 0,
        applicantPhoneNo: 
        this.paymentGatewayCode == "JODO"
          ? this.jodoProductType == "CRED"
            ? this.CardlessEMICardForm?.value?.phone
            : this.userDetails?.phone
          : this.paymentGatewayCode == "SHOPSE"
            ? this.CardlessEMICardForm?.value?.phone
            : this.paymentGatewayCode == "EARLY_SALARY"
              ? this.EarlySalaryEMICardForm?.value?.phone
              : undefined,
        portal:"website",
        userPlatform: 'website'
      };
    this.SubscriptionService.createCartOrder(object).subscribe((resp: any) => {
      console.log(resp)
      this.subscriptionbillingUtility.generatedOrderDetails = resp;
      this.subscriptionbillingUtility.orderId = resp?.orderId;
      this.subscriptionbillingUtility.totalPaidAmount = finalazorpayAmount;
      let amount = object?.amountAfterDiscount * 100; //amountAfterDiscount for razor pay
      if (amount == 0 && this.subscriptionbillingUtility.discountCode) {
        let planDetailsCapture = this.subscriptionbillingUtility?.paidOptions?.[0];
        this.subscriptionbillingUtility.selectedDuration.status = 'success';
        this.router.navigate(['./enroll-subscription/enroll-payementVerification'], {
          paidAmount: resp?.paidAmount,
          ...this.subscriptionbillingUtility.selectedPackage,
          packageName: this.subscriptionbillingUtility?.selectedPackage?.name, 
          ...this.subscriptionbillingUtility.selectedDuration, 
          ...this.options, ...{ userOrderId: this.subscriptionbillingUtility.orderId },  
          ...{ planDetailsCapture: planDetailsCapture }, 
          ...{ paymentStatusCapture: this.subscriptionbillingUtility.paymentStatusCapture }, 
          ...{ productSet: this.subscriptionbillingUtility.selectedPackage.productSet },
          isAits: this.isAits
        });
        this.spinner.hide();
      } else {
        if(this.paymentGatewayCode == "RAZORPAY") {
          if(this.customPaymntType==="card") {
            this.payUsingRazorPayCustomWebSDK(
              this.subscriptionbillingUtility, this.selctedCardData
            );
          } else if(this.customPaymntType==="net_banking") {
            this.payUsingRazorPayCustomWebSDK(
              this.subscriptionbillingUtility, { method: "netbanking", bank: this.selectedBankName }
            );
          } else if(this.customPaymntType==="upi") {
            this.payUsingRazorPayCustomWebSDK(
              this.subscriptionbillingUtility, this.upiMode=="QR" ? { method: "upi" } : { method: "upi", vpa: this.UPIControlForm.value.vpa }
            );
          } else if(this.customPaymntType==="wallet") {
            this.payUsingRazorPayCustomWebSDK(
              this.subscriptionbillingUtility, { method: "wallet", wallet: this.selectedWalletCode }
            );
          } else if(this.customPaymntType==="emi") {
            this.payUsingRazorPayCustomWebSDK(
              this.subscriptionbillingUtility, this.isCardlessEmi ? { method: "cardless_emi", provider: this.selectedCardLessEmi?.code } : this.selctedEMICardData
            );
          } else if(this.customPaymntType==="pay_later") {
            if(this.selectedPaylaterMethod == "icic") {
              this.payUsingRazorPayCustomWebSDK(
                this.subscriptionbillingUtility, { method: "paylater", provider: "icic" }
              );
            }
          }
        } else if(this.paymentGatewayCode == "SIMPL") {
          const options = {
            name: this.subscriptionbillingUtility.userDetails.firstName + ' ' + this.subscriptionbillingUtility.userDetails.lastName,
            amount: 100, // razorpay takes amount in paisa
            prefill: {
              name: this.subscriptionbillingUtility.userDetails?.firstName + ' ' + this.subscriptionbillingUtility.userDetails?.lastName,
              email: this.subscriptionbillingUtility.userDetails?.email || '', // add your email id
              contact: this.subscriptionbillingUtility.userDetails?.phone 
            },
          }
          if(resp?.simplTransactionResponse?.success) {
            this.redirectToPaymentVerificationPageAfterSimplAndBajajPaymentSuccess(this.subscriptionbillingUtility, resp, options);
          } else {
            this.redirectToPaymentVerificationPageAfterSimplPaymentFailure(this.subscriptionbillingUtility, resp, options);
          }
          this.spinner.hide();
        } else if(this.paymentGatewayCode == "BAJAJFINANCE") {
          if(resp?.respCode == "0") {
            this.bajajCreateCartOrderResp = resp;
            this.bajajFinanceNoCostEmiData.isDisplayOtp = true;
            this.startCountdown(59);
          } else {
            this.BajajEMICardErrorMSg = resp?.message;
          } 
          this.spinner.hide();
        } else if(this.paymentGatewayCode == "JODO") {
          this.doJodoPayment();
        } else if(this.paymentGatewayCode == "SHOPSE") {
          this.doShopsePayment();
        } else if(this.paymentGatewayCode == "EARLY_SALARY") {
          this.doEarlySalaryPayment();
        }
      }
    }, (err: any) => {
      if(this.paymentGatewayCode == "SIMPL") {
        const options = {
          name: this.subscriptionbillingUtility.userDetails.firstName + ' ' + this.subscriptionbillingUtility.userDetails.lastName,
          amount: 100, // razorpay takes amount in paisa
          prefill: {
            name: this.subscriptionbillingUtility.userDetails?.firstName + ' ' + this.subscriptionbillingUtility.userDetails?.lastName,
            email: this.subscriptionbillingUtility.userDetails?.email || '', // add your email id
            contact: this.subscriptionbillingUtility.userDetails?.phone 
          },
        }
        this.redirectToPaymentVerificationPageAfterSimplPaymentFailure(this.subscriptionbillingUtility, { bajajSimplData : err }, options);
      }
      this.spinner.hide();
    });
  }

  redirectToPaymentVerificationPageAfterSimplAndBajajPaymentSuccess(subscriptionbillingUtility, createOrderResp, options) {
    this.subcriptionPayment = subscriptionbillingUtility;
    let emiData = this.subcriptionPayment.paidOptions;
    let planDetailsCapture = this.subcriptionPayment?.paidOptions?.[0];
    if (!this.subcriptionPayment.selectedPackage) {
      this.subcriptionPayment.selectedPackage = subscriptionbillingUtility.partnerPaymentSuccess;
    } else {
      this.subcriptionPayment.selectedPackage.status = subscriptionbillingUtility.partnerPaymentSuccess;
    }
    const resp = this.paymentGatewayCode == "SIMPL" ? createOrderResp?.simplUserOrderPaymentResponse : createOrderResp;
    this.subcriptionPayment.paymentStatusCapture = resp;

    if (this.subscriptionbillingUtility?.courseSelected?.id) {
      let userDetails = this.SubscriptionService.getuserDetails();
      let body = {
        courses: this.subscriptionbillingUtility?.courseSelected?.id,
        batches: this.subscriptionbillingUtility?.selectedBatch?.id,
        student: {
          id:
            this.userDetails?.userId?.toString() ||
            userDetails?.userId?.toString(),
          firstName: this.userDetails?.firstName || userDetails?.firstName,
          lastName: this.userDetails?.lastName || userDetails?.lastName,
        },
        tenant: environment?.tenant,
        // gatewayOrderId: res?.razorpay_order_id,
        // razorpayPaymentId: res?.razorpay_payment_id,
        // razorpaySignature: res?.razorpay_signature,
      };
      this.spinner.hide();
    }
    // if(this.subscriptionSelectedData?.liveclass_courseID) {
    // this.spinner.show();
    this.router.navigate(['./enroll-subscription/enroll-payementVerification'],
                { 
                  ...this.subscriptionbillingUtility.selectedPackage,
                  packageName: this.subscriptionbillingUtility?.selectedPackage?.name, 
                  ...this.subscriptionbillingUtility.selectedDuration, 
                  ...options, ...{ userOrderId: resp?.userOrder?.id }, 
                  ...{ emiData: emiData }, 
                  ...{ planDetailsCapture: planDetailsCapture }, 
                  ...{ paymentStatusCapture: this.subscriptionbillingUtility.paymentStatusCapture }, 
                  ...{ productSet: this.subscriptionbillingUtility.selectedPackage.productSet },
                  ...{ jodoProductType: this.jodoProductType},
                  ...{ downloadInvoiceUserOrderID: resp?.userOrder?.id },
                  ...{ paymentGatewayCode: this.paymentGatewayCode},
                  isAits: this.isAits })

    this.spinner.hide();

  }
  redirectToPaymentVerificationPageAfterSimplPaymentFailure(subscriptionbillingUtility, createOrderResp, options) {
    // add current page routing if payment fails
    subscriptionbillingUtility.selectedPaymentData = 
    this.paymentGatewayCode == "SIMPL" 
    ? { method: "paylater" }
    : this.paymentGatewayCode == "BAJAJFINANCE" || (this.paymentGatewayCode == "JODO" && this.jodoProductType == "CRED") || this.paymentGatewayCode == "SHOPSE" || this.paymentGatewayCode == "EARLY_SALARY"
      ? { method: "emi" }
      : this.paymentGatewayCode == "JODO" && this.jodoProductType == "FLEX" 
        ? { method: "pay_in_part", jodoPartPayment: this.subscriptionbillingUtility?.jodoemiOptions, partPaymentTabNo: 0 } : {};
    this.subcriptionPayment = subscriptionbillingUtility;
    let emiData = this.subcriptionPayment.paidOptions;
    let planDetailsCapture = this.subcriptionPayment?.paidOptions?.[0];
    if (!subscriptionbillingUtility.selectedPackage) {
      subscriptionbillingUtility.selectedPackage = {};
    }
    subscriptionbillingUtility.selectedPackage.status = 'error';
    //? checking cartcount
    $('#paymentfail').modal('show');
    // this.router.navigate(['./enroll-subscription/enroll-payementVerification'],
    //           { 
    //             ...subscriptionbillingUtility.selectedPackage, 
    //             ...this.subscriptionbillingUtility.selectedDuration, 
    //             ...this.options, 
    //             ...{ emiData: emiData }, 
    //             ...{ planDetailsCapture: planDetailsCapture }, 
    //             ...{ paymentStatusCapture: subscriptionbillingUtility.paymentStatusCapture }, 
    //             ...{ productSet: this.subscriptionbillingUtility.selectedPackage.productSet }, 
    //             ...{ selectedPaymentData: subscriptionbillingUtility.selectedPaymentData }, 
    //             ...{ failureMessage: this.paymentGatewayCode == "JODO" ? "" : createOrderResp?.gatewayData?.message || createOrderResp?.gatewayData?.bajajResponse?.RESPDESC || "" },
    //             ...{ paymentGatewayCode: this.paymentGatewayCode},
    //             ...{ jodoProductType: ""}, });
    
    this.spinner.hide();
  }

  
  calculatePaymentOptions(emitype, totalData) {

    this.subscriptionbillingUtility.selectedCartItems = totalData?.map((cartItem) => {
      var findIndex_partPayment = cartItem?.partPaymentPlanMasterDtoList?.findIndex((installmentList) => installmentList?.partPaymentPlanDetailsDto.length == emitype);
      cartItem.selectedPartPaymentPlanMasterDtoList = [];
      if (findIndex_partPayment != -1) {
        cartItem.selectedPartPaymentPlanMasterDtoList = [cartItem?.partPaymentPlanMasterDtoList[findIndex_partPayment]]
        let maxDaysLimit = Math.max(
          ...(cartItem?.partPaymentPlanMasterDtoList[findIndex_partPayment]
            ?.partPaymentPlanDetailsDto?.map((part) => part?.daysLimit) ?? [])
        );
        this.lastPartPaymentDate = moment()
          .add(maxDaysLimit, 'days')
          .set('hour', 23)
          .set('minute', 59)
          .format('YYYY-MM-DD HH:mm:ss');
      } else if (findIndex_partPayment == -1 && cartItem?.partPaymentPlanMasterDtoList?.length) {
        cartItem.selectedPartPaymentPlanMasterDtoList = [cartItem?.partPaymentPlanMasterDtoList[0]]
      }
      return cartItem
    })?.filter((v) => v?.selectedPartPaymentPlanMasterDtoList?.length)
    
    let fullpaymentsAmount =  this.subscriptionbillingUtility.selectedCartItems.reduce( (a,v )=>{
     a.push(...(v.partPaymentPlanMasterDtoList?.find(innv=>innv?.partPaymentPlanDetailsDto?.length == 1).partPaymentPlanDetailsDto) )
    return a},[]) 
    let maxPercentage = Math.max(...fullpaymentsAmount.map(v=>v.discountPer));
    this.discountPercentage = maxPercentage
    this.subscriptionbillingUtility.partPaymentDiscountper = maxPercentage;
    this.subscriptionbillingUtility.totalAmount_withoutdiscount  =   this.subscriptionbillingUtility.allCartItems.reduce((a,v)=>{
    a= a +(v?.subscription?.amount * v.quantity)
    return a },0)
     this.subscriptionbillingUtility.fulltotalAmount = this.subscriptionbillingUtility.totalAmount_withoutdiscount*((100-maxPercentage)/100) 
     this.subscriptionbillingUtility.emiPayLaterFulltotalAmount = this.subscriptionbillingUtility.totalAmount_withoutdiscount;
    this.totalPartPaymentAmt = this.subscriptionbillingUtility.selectedCartItems.reduce((acc,v)=>{
      acc = acc  + v.selectedPartPaymentPlanMasterDtoList[0]?.partPaymentPlanDetailsDto[0]?.applicableAmount
      return acc
    },0)
    if(this.customPaymntType == "emi") {
      this.checkVaildEmiData();
    }
  }

  payInparts(emitype, totalData,data:any = {}) {
    this.partPayment=emitype;
    this.subscriptionbillingUtility.selectedEmiPart = emitype;
    if (this.subscriptionbillingUtility.discountCode) {
      this.applyDiscountCode("manual")
    } else {
      this.calculatePaymentOptions(emitype, totalData)
    }
  }
  openPartapayBtn() {
    this.openPartapaystatus = !this.openPartapaystatus;
  }

  //common code for razorpay
  setRazorpayOptions(subscriptionbillingUtility) {
    this.subscriptionbillingUtility = subscriptionbillingUtility;
    let emiData = this.subscriptionbillingUtility.paidOptions;
    let planDetailsCapture = this.subscriptionbillingUtility?.paidOptions?.[0];
    this.options2 = {
      key: environment.razorkey,// 'rzp_live_NoGaIDZ74lwGZa',//"rzp_test_9y0agtAfQDcO5L",//rzp_test_tiOVruBsu1t5PB -radha',rzp_live_NoGaIDZ74lwGZa-staging // add razorpay key here
      name: subscriptionbillingUtility.userDetails.firstName + ' ' + subscriptionbillingUtility.userDetails.lastName,
      description: 'Subscription',
      amount: 100, // razorpay takes amount in paisa
      prefill: {
        name: subscriptionbillingUtility.userDetails?.firstName + ' ' + subscriptionbillingUtility.userDetails?.lastName,
        email: subscriptionbillingUtility.userDetails?.email, // add your email id
        contact: subscriptionbillingUtility.userDetails?.phone
      },
      notes: {},
      theme: {
        color: '#3880FF'
      },
      "order_id": subscriptionbillingUtility.generatedOrderDetails.gatewayOrderId,
      handler: this.paymentHandler.bind(this),
      modal: {
        ondismiss: (() => {
          this.zone.run(() => {
            // add current page routing if payment fails
            subscriptionbillingUtility.selectedPackage.status = 'error';
            let routing = {
              billingAddress: subscriptionbillingUtility.billingAddress,
              selectedPin: subscriptionbillingUtility.selectedPin,
              selectedState: subscriptionbillingUtility.selectedState
            }
            let body = {
              "amount": subscriptionbillingUtility.selectedPackage?.amount,
              "creationDate": new Date().toISOString(),
              "status": "aborted",
              "userId": subscriptionbillingUtility.userDetails?.userId,
              "userOrderId": subscriptionbillingUtility.orderId
            }
            this.SubscriptionService.paymentABortedbyUser(body).subscribe((resp) => {

            })
            this.router.navigate(['./enroll-subscription/enroll-payementVerification'],
              { ...this.subscriptionbillingUtility.selectedPackage,
                packageName: this.subscriptionbillingUtility?.selectedPackage?.name, 
                ...this.subscriptionbillingUtility.selectedDuration, 
                ...this.options, 
                ...{ emiData: emiData }, 
                ...{ planDetailsCapture: planDetailsCapture }, 
                ...{ paymentStatusCapture: this.subscriptionbillingUtility.paymentStatusCapture }, 
                ...{ productSet: this.subscriptionbillingUtility.selectedPackage.productSet },
                isAits: this.isAits })

          })
        })
      }
    }

    // //create order id
    // this.rzp = new this.SubscriptionService.nativeWindow['Razorpay'](this.options);
    // this.rzp.open();
    // this.rzp.on('payment.failed', (response: any) => {
    // });
  }

  paymentHandler(subscriptionbillingUtility: any, res: any, options: any) {
    console.log(subscriptionbillingUtility);
    let emiData = this.subscriptionbillingUtility.paidOptions;
    let planDetailsCapture = this.subscriptionbillingUtility?.paidOptions?.[0];
    this.zone.run(() => {
      if (res?.razorpay_signature) {
        var obj = {
          "gatewayCode": "RAZORPAY",
          "paymentMode": "ONLINE",
          "razorpayOrderId": res?.razorpay_order_id,
          "razorpayPaymentId": res?.razorpay_payment_id,
          "razorpaySignature": res?.razorpay_signature,
          "userOrderId": this.subscriptionbillingUtility.orderId,
          "batchId": this.subscriptionbillingUtility?.selectedBatch?.id ?? '',
          "ruleID": this.subscriptionbillingUtility.selectedPackage?.id ?? '',
          "userOrderPaymentPlanCaptureDetailsRequest": this.subscriptionbillingUtility.payValue == 'fullpayment' ?
            [{
              "paidAmount": this.subscriptionbillingUtility.fullPaymentOptions?.amount,
              "partAmount": this.subscriptionbillingUtility.fullPaymentOptions?.amount,
              "partPlanDetailsId": this.subscriptionbillingUtility.fullPaymentOptions?.planDetailId
            }]
            : this.subscriptionbillingUtility.emiOptions?.map((val, index) => {
              return {
                "paidAmount": index == 0 ? val?.amount : 0,
                "partAmount": val?.amount,
                "partPlanDetailsId": val?.planDetailId
              }
            }) ?? [],
          "paymentPlanCaptureDetailsId": this.subscriptionbillingUtility.payValue == 'fullpayment' ? this.subscriptionbillingUtility.fullPaymentOptions?.planDetailId : this.subscriptionbillingUtility.emiOptions?.[0]?.planDetailId,
          "portal":"website"
        }
        this.SubscriptionService.userPayment(obj).subscribe((resp: any) => {
          this.subscriptionbillingUtility.selectedPackage.status = 'success';
          this.subscriptionbillingUtility.paymentStatusCapture = resp;
          if (this.subscriptionbillingUtility?.courseSelected?.id) {
            this.spinner.show();
            console.log(this.userDetails)
            let body = {
              "courses": this.subscriptionbillingUtility?.courseSelected?.id,
              "batches": this.subscriptionbillingUtility.selectedBatch?.id,
              "student": {
                "id": this.subscriptionbillingUtility?.localUserData?.userId?.toString(),
                "firstName": this.userDetails?.firstName,
                "lastName": this.userDetails?.lastName,
              },
              "gatewayOrderId": res?.razorpay_order_id,
              "razorpayPaymentId": res?.razorpay_payment_id,
              "razorpaySignature": res?.razorpay_signature,
            }
            this.spinner.hide();
            this.router.navigate(['./enroll-subscription/enroll-payementVerification'],
              { ...this.subscriptionbillingUtility.selectedPackage, 
                packageName: this.subscriptionbillingUtility?.selectedPackage?.name,
                ...this.subscriptionbillingUtility.selectedDuration, 
                ...this.options, ...{ userOrderId: obj?.userOrderId }, 
                ...{ emiData: emiData }, 
                ...{ planDetailsCapture: planDetailsCapture }, 
                ...{ paymentStatusCapture: this.subscriptionbillingUtility.paymentStatusCapture }, 
                ...{ productSet: this.subscriptionbillingUtility.selectedPackage.productSet },
                isAits: this.isAits });
          }
          else {
            //   if(this.isScoreExam){
            //     this.registerScoreObj()
            //     // this.routingUrl = './subscription/paymentresult'
            //   }
            //   this.router.navigate([this.routingUrl],
            //   { ...this.subscriptionbillingUtility.selectedPackage, ...this.options, ...{ userOrderId: obj?.userOrderId } ,
            //   ...{selectedExamDate:this.subscriptionbillingUtility?.selectedExamDate,selectedExamTime:this.subscriptionbillingUtility?.selectedExamTime}})
            this.spinner.hide();
            this.router.navigate(['./enroll-subscription/enroll-payementVerification'],
              { ...this.subscriptionbillingUtility.selectedPackage,
                packageName: this.subscriptionbillingUtility?.selectedPackage?.name, 
                ...this.subscriptionbillingUtility.selectedDuration, 
                ...this.options, 
                ...{ userOrderId: obj?.userOrderId }, 
                ...{ emiData: emiData }, 
                ...{ planDetailsCapture: planDetailsCapture }, 
                ...{ paymentStatusCapture: this.subscriptionbillingUtility.paymentStatusCapture }, 
                ...{ productSet: this.subscriptionbillingUtility.selectedPackage.productSet,
                isAits: this.isAits } })
          }
          // }


        })
      }
    });
  }

  // custom payment event start
customPaymntTypeEvent(event){
  //console.log(event);
  this.customPaymntType = event;
  this.customPaymntPanelStatus = true;
  this.innerPanelName = '';
  if(event == "emi") {
    this.checkVaildEmiData();
  } else if(event == "pay_later") {
    this.checkSimpleEligibility("check_eligibility");
  }
}
customPaymntPanelClose(){
  this.customPaymntPanelStatus = false;
}

toggleInnerPanel(getInnerPanelName){
  this.innerPanelName = getInnerPanelName;
}

// pay using razorpay for card, netbanking, upi, wallet
makePayment() {
  this.paymentGatewayCode = 'RAZORPAY';
  if(this.paymentType == "fullpayment") {
    this.payValue(this.subscriptionbillingUtility.fullPaymentOptions?.amount,'fullpayment');
  } else {
    console.log((this.subscriptionbillingUtility.emiOptions?.length)?(this.subscriptionbillingUtility.emiOptions[0].amount):0)
    this.payValue((this.subscriptionbillingUtility.emiOptions?.length)?(this.subscriptionbillingUtility.emiOptions[0].amount):0,'partpayment')
  }
}

get newCard() { return this.newCardForm.controls}

addCard() {
  console.log(this.newCardForm);
  this.selctedCardData = {
    method: "card",
    "card[name]": this.newCardForm.value.card_placeholder_name,
    "card[number]": this.newCardForm.value.card_number,
    "card[expiry]": this.newCardForm.value.expiry,
    "card[cvv]": this.newCardForm.value.cvv,
  }
  this.SubscriptionService.checkIsEmiCardCorrect(this.newCardForm.value.card_number.toString().slice(0, 6))
  .subscribe((response) => {
  const carddata = response;
  this.transactionCountryCode = carddata?.country;
  this.transactionType = carddata?.type;
  this.makePayment();
  }, (error) => {
    console.log(error);
  })
}

createCardForm() {
  this.newCardForm = this.fb.group({
    card_placeholder_name: new FormControl('', [Validators.required,  Validators.pattern('^((?:[A-Za-z]+ ?){1,3})$')]),
    card_number: new FormControl('',[Validators.required, Validators.pattern('^[0-9]{13,19}$')]),
    expiry: new FormControl('',[Validators.required, Validators.pattern('^(0[1-9]|1[0-2])\/([0-9]{2})$'), this.checkCardExpiry()]),
    cvv: new FormControl('',[Validators.required, Validators.pattern('^[0-9]{3,4}$')]),
  })
}

checkCardExpiry(): ValidatorFn {
  return (control: AbstractControl) => {
    const val = control.value;
    let month_year = val?.split("/");
    const month = month_year?.[0];
    const year = month_year?.[1];
    const curYearLastTwoDigits = new Date().getFullYear().toString().substr(-2);
    const curMonth = new Date().getMonth()+1;
    const isValid = (year && (Number(year) > Number(curYearLastTwoDigits))) || (year && (Number(year) == Number(curYearLastTwoDigits)) && (Number(month) >= Number(curMonth)));
    return isValid ? null:  {'cardExpiryCheck': true};
  };
}

dateKeyPress(e) {
  return e.charCode >= 48 && e.charCode <= 57;
}

addSlash(e) {
  if(e.target.value?.length == 1 && e.target.value>=2 && e.target.value<=9) {
    e.target.value = "0" + e.target.value;
    this.previousExpiryDateLen = 1;
  }
  if (
    e.target.value == '/' ||
    /^\d\/$/.exec(e.target.value) ||
    /^\d\d\/\/$/.exec(e.target.value) ||
    /^\d\d\/\d\/$/.exec(e.target.value)
  ) {
    e.target.value = e.target.value.slice(0, -1);
  }
  console.log(e)
  var monthRegex= /^\d\d$/;
  var isMonthEntered = monthRegex.exec(e.target.value);
  if (e.key >= 0 && e.key <= 9 && isMonthEntered) {
    e.target.value = e.target.value + "/";
  } else if(isMonthEntered && this.previousExpiryDateLen == 1) {
    e.target.value = e.target.value + "/";
  }
  this.previousExpiryDateLen = e.target.value?.length;
};

removeSlash(e) {
  var monthAndSlashRegex = /^\d\d\/$/;
  var isMonthAndSlashEntered = monthAndSlashRegex.exec(e.target.value);
  if (isMonthAndSlashEntered && e.key === 'Backspace') {
    e.target.value = e.target.value.slice(0, -1);
  }
};

createBankForm() {
  this.bankControlForm = this.fb.group({
    bankName: new FormControl('', [this.checkIsBankName()]),
  });
  this.filteredOptions = this.bankControlForm.get('bankName')!.valueChanges.pipe(
    startWith(''),
    map(value => (typeof value === 'string' ? value : value.name)),
    map(name => (name ? this._filter(name) : this.options.slice())),
  );
}

checkIsBankName(): ValidatorFn {
  return (control: AbstractControl) => {
    const val = typeof control.value === 'string' ? control.value : control.value?.name;
    const isValid = val == "" || this.options.findIndex((bank) => bank.name === val) != -1;
    return isValid ? null:  {'bankNameCheck': isValid};
  };
}

selectedBank(bankCode: any) {
  this.createBankForm()
  this.selectedBankName = bankCode;
}

payUsingNetBank() {
  if(!this.selectedBankName) {
    let bankName = this.bankControlForm.value.bankName?.name;
    let bankDetails = this.razorPayData?.methods?.netbanking;
    for (const key in bankDetails) {
      if (bankDetails.hasOwnProperty(key)) {
        if(bankName == bankDetails[key]) {
          this.selectedBankName = key;
        }
      }
    }
  }
  this.makePayment();
}

createUPIForm() {
  this.UPIControlForm = this.fb.group({
    vpa: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9\-._-]{2,256}@[a-zA-Z]{2,64}$')]),
  });
  this.UPIControlForm.get('vpa')!.valueChanges.subscribe((value) => {
    this.isUPIVerified=false;
    this.isUPIValid=false;
  })
}

checkIsUPICorrect() {
  const payload = {
    entity: "vpa",
    value: this.UPIControlForm.value.vpa
  }
  this.upicheckLoading = true;
  this.SubscriptionService.checkIsUPICorrect(payload).subscribe((response) => {
    console.log(response)
    if(response?.success) {
      this.isUPIValid = true;
    } else {
      this.isUPIValid = false;
    }
    this.upicheckLoading = false;
  }, (err) => {
    this.isUPIValid = false;
    this.upicheckLoading = false;
  })
  this.isUPIVerified = true;
}

payUsingUPI(upimode: any) {
  this.upiMode = upimode;
  this.makePayment();
}

// wallet
selectedWallet(walletCode: any) {
  this.selectedWalletCode = walletCode;
}

payUsingWallet() {
  this.makePayment();
}

// emi
checkVaildEmiData() {
  this.spinner.show();
  this.validEmiData = this.emi_data
    .filter(x => x.plans.filter(y => this.subscriptionbillingUtility?.emiPayLaterFulltotalAmount >= y.min_amount)?.length>0);
  this.hasDebitCardEMI = this.validEmiData.filter(x => x.mode=='all' || x.mode=='debit').length;
  this.hasCreditCardEMI = this.validEmiData.filter(x => x.mode=='all' || x.mode=='credit').length;
  let rzp = new this.razorpayapiService.nativeWindow['Razorpay']({  
    key: environment.razorkey,
    amount: Math.round((this.subscriptionbillingUtility.emiPayLaterFulltotalAmount + Number.EPSILON) * 100)
  });
  rzp.once('ready', (response) => {
    this.cardLessEmis = [];
    if(response?.methods?.cardless_emi?.["walnut369"]) {
      this.cardLessEmis.push({ name: "Walnut 369", code: "walnut369" })
    }
    // if(response?.methods?.cardless_emi?.["earlysalary"] && environment?.showEarlySalary) {
    //   this.cardLessEmis.push({ name: "EarlySalary", code: "earlysalary" })
    // }
    if(this.customPaymntType == "emi") {
      if (
        !(
          (this.bajajFinanceNoCostEmiData?.showBajaj &&
            this.bajajFinanceNoCostEmiData?.min_amount <=
              this.subscriptionbillingUtility.emiPayLaterFulltotalAmount &&
            this.subscriptionbillingUtility.emiPayLaterFulltotalAmount <=
              this.bajajFinanceNoCostEmiData?.max_amount) ||
          ((this.cardLessEmis?.length ||
            this.hasDebitCardEMI ||
            this.hasCreditCardEMI) && !this.isFromBajajFinservAppInApp)
        )
      ) {
        this.customPaymntTypeEvent("card");
      }
    }
    this.markRef.detectChanges();
  })
  this.spinner.hide();
}

setSelectedbankEMIData(panelName:any, bankEMIData: any, mode: any) {
  console.log(this.subscriptionbillingUtility.emiPayLaterFulltotalAmount);
  console.log(this.subscriptionbillingUtility?.fullPaymentOptions?.amount);
  this.toggleInnerPanel(panelName);
  console.log(bankEMIData)
  let tempBankEMIData = {...bankEMIData};
  if(mode == "credit" || mode =="debit") {
    tempBankEMIData.plans.sort((plan_a, plan_b) => plan_a.duration-plan_b.duration)
      .map((plan) => {
        // emi amount for month formulae is p*r*(1+r)**n/((1+r)**n - 1)
        let p = this.subscriptionbillingUtility?.emiPayLaterFulltotalAmount; // principal amount
        let r = plan.interest/(12*100); // interest per month
        let n = plan.duration; // months
        plan.amountForMonth = plan.interest==0 ? this.subscriptionbillingUtility?.emiPayLaterFulltotalAmount/n : p*r*(1+r)**n/((1+r)**n - 1);
        plan.noCostEmiDiscount = 0;
        return plan;
      });
  } else {
    const bajajPlans = this.getBajajDuratios();
    tempBankEMIData.plans = [];
    bajajPlans.map((bajajPlan) => {
      let p = this.subscriptionbillingUtility.emiPayLaterFulltotalAmount; // principal amount
      let r = 15/(12*100); // interest per month
      let n = bajajPlan?.tenor; // months
      tempBankEMIData.plans.push({
        interest: 0,
        min_amount: environment.Bajaj.min_amount,
        "duration": bajajPlan?.tenor,
        "schemeId": bajajPlan?.schemeId,
        code: "BAJAJ",
        amountForMonth: p/n,
        noCostEmiDiscount: n*p*r*(1+r)**n/((1+r)**n - 1) - p
      })
    })
  }
  console.log(tempBankEMIData);
  this.selected_bank_emi_data = tempBankEMIData;
  this.emiMode = mode;
}

getBajajDuratios() {
  return environment.Bajaj.Durations.map((scheme) => {
    return { tenor: scheme?.tenor, schemeId: scheme?.schemeId };
  })
}

setSelectedEMIPlan(panelName: any, plan: any, index: any) {
  this.toggleInnerPanel(panelName);
  this.selectedEmiPlan = {...plan, index};
  if(plan?.code == "BAJAJ") {
    this.createBajajEMICardForm();
    this.bajajFinanceNoCostEmiData.isDisplayOtp = false;
  }
}

createEMICardForm() {
  this.EMICardForm = this.fb.group({
    card_placeholder_name: new FormControl('', [Validators.required,  Validators.pattern('^((?:[A-Za-z]+ ?){1,3})$')]),
    card_number: new FormControl('',[Validators.required, Validators.pattern('^[0-9]{13,19}$')]),
    expiry: new FormControl('',[Validators.required, Validators.pattern('^(0[1-9]|1[0-2])\/([0-9]{2})$'), this.checkCardExpiry()]),
    cvv: new FormControl('',[Validators.required, Validators.pattern('^[0-9]{3,4}$')]),
  })
  this.EMICardForm.get("card_number")!.valueChanges.subscribe((value) => {
    this.EMICardErrorMSg = "";
  })
}
createBajajEMICardForm() {
  this.BajajEMICardForm = this.fb.group({
    card_number: new FormControl('',[Validators.required, Validators.pattern('^([0-9]{13,19}|[6-9][0-9]{9})$')]),
    bajajOtp: new FormControl('',[Validators.required, Validators.pattern('^([0-9]{6})$')]),
  });
  this.BajajEMICardForm.get("card_number")!.valueChanges.subscribe((value) => {
    this.BajajEMICardErrorMSg = "";
  });
  this.BajajEMICardForm.get("bajajOtp")!.valueChanges.subscribe((value) => {
    this.BajajEMIOtpErrorMSg = "";
  });
}
createOrderAndGetOtpWithBajajNoCostEMI() {
  this.paymentGatewayCode = "BAJAJFINANCE";
  this.selctedBajajEMICardData = {
    phone: this.BajajEMICardForm.value.card_number.length == 10 ? this.BajajEMICardForm.value.card_number : "",
    cardNo: this.BajajEMICardForm.value.card_number.length > 10 ? this.BajajEMICardForm.value.card_number : "",
    otp: "",
  }
  this.payValue(this.subscriptionbillingUtility.fullPaymentOptions?.amount,'fullpayment');
}
resendBajajOtp() {
  const payload = {
    bajajMobileNo: this.selctedBajajEMICardData?.phone,
    cardNo: this.selctedBajajEMICardData?.cardNo,
    ipAdd: this.ipAddress,
    orderId: this.bajajCreateCartOrderResp?.orderId,
    tanure: this.selectedEmiPlan?.duration?.toString(),
    schemeId: this.selectedEmiPlan?.schemeId
  }
  this.SubscriptionService.resendBjajOtp(payload).subscribe((resp: any) => {
    this.subscriptionbillingUtility.generatedOrderDetails = resp;
    if(resp?.respCode == "0") {
      this.resendotp = false;
      this.bajajCreateCartOrderResp = resp;
      this.bajajFinanceNoCostEmiData.isDisplayOtp = true;
      this.BajajEMICardErrorMSg = "";
      this.startCountdown(59);
    } else {
      this.BajajEMICardErrorMSg = resp?.message;
    }
  })
}

startCountdown(seconds) {
  // this.counter = seconds;
  // const interval = setInterval(() => {
  //   this.counter--;
  //   if (this.counter == 0) {
  //     this.resendotp = true;
  //     clearInterval(interval);
  //   }
  // }, 1000);
  if(this.paymentGatewayCode == "BAJAJFINANCE") {
    this.bajajFinanceNoCostEmiData.counter = seconds;
    const bajajInterval = setInterval(() => {
      this.bajajFinanceNoCostEmiData.counter--;
      if (this.bajajFinanceNoCostEmiData?.counter == 0) {
        this.bajajFinanceNoCostEmiData.resendotp = true;
        clearInterval(bajajInterval);
      }
    }, 1000);
  } else if(this.paymentGatewayCode == "EARLY_SALARY"){
    this.earlySalary.counter = seconds;
    const earlySalaryInterval = setInterval(() => {
      this.earlySalary.counter--;
      if (this.earlySalary?.counter == 0) {
        this.earlySalary.resendotp = true;
        clearInterval(earlySalaryInterval);
      }
    }, 1000);
  }
}

payUsingBajajNoCostEMI() {
  this.paymentGatewayCode = "BAJAJFINANCE";
  this.selctedBajajEMICardData = {
    phone: this.BajajEMICardForm.value.card_number.length == 10 ? this.BajajEMICardForm.value.card_number : "",
    cardNo: this.BajajEMICardForm.value.card_number.length > 10 ? this.BajajEMICardForm.value.card_number : "",
    otp: this.BajajEMICardForm.value.bajajOtp,
  }
  this.payUsingBajajWithOTP();
}
conv_number(expr, decplaces) {
  var str = "" + Math.round(eval(expr) * Math.pow(10,decplaces));
  while (str.length <= decplaces) {
    str = "0" + str;
  }

  var decpoint = str.length - decplaces;
  return (str.substring(0,decpoint) + "." + str.substring(decpoint,str.length));
}

// Parameters are rate, total number of periods, payment made each period and future value
pv(rate, nper, pmt, fv) {
  let pv_value;
  rate = parseFloat(rate);
  nper = parseFloat(nper);
  pmt = parseFloat(pmt);
  fv = parseFloat(fv);
  if ( nper == 0 ) {
    alert("Why do you want to test me with zeros?");
    return(0);       
  }
  if ( rate == 0 ) { // Interest rate is 0
    pv_value = -(fv + (pmt * nper));
  } else {
    let x = Math.pow(1 + rate, -nper); 
    let y = Math.pow(1 + rate, nper);
    pv_value = - ( x * ( fv * rate - pmt + y * pmt )) / rate;
  }
  pv_value = this.conv_number(pv_value, 2);
  return (pv_value);
}
// part payment
payUsingEMI() {
  console.log(this.EMICardForm);
  this.selctedEMICardData = {
    method: "emi",
    "card[name]": this.EMICardForm.value.card_placeholder_name,
    "card[number]": this.EMICardForm.value.card_number,
    "card[expiry]": this.EMICardForm.value.expiry,
    "card[cvv]": this.EMICardForm.value.cvv,
    emi_duration: this.selectedEmiPlan?.duration,
    // offer id for No Cost EMI
    offer_id: this.selectedEmiPlan?.offer_id
  }
  console.log(this.selctedEMICardData)
  // this.makePayment();
  this.SubscriptionService.checkIsEmiCardCorrect(this.EMICardForm.value.card_number.toString().slice(0, 6))
    .subscribe((response) => {
      const carddata = response;
      if (
        this.selected_bank_emi_data?.code
          ?.toLowerCase()
          .includes(carddata?.issuer?.toLowerCase()) &&
        carddata?.type == this.emiMode
      ) {
        this.isCardlessEmi = false;
        this.makePayment();
      } else {
        this.EMICardErrorMSg = `Please enter ${this.selected_bank_emi_data.name} ${this.emiMode=="credit" ? "Credit" : this.emiMode=="debit" ? "Debit" : ""} card`;
      }
    }, (error) => {
      this.EMICardErrorMSg = `Please enter ${this.selected_bank_emi_data.name} ${this.emiMode=="credit" ? "Credit" : this.emiMode=="debit" ? "Debit" : ""} card`;
    })
}

payUsingCardLessEmi(cardlessEMI: any) {
  this.isCardlessEmi = true;
  this.selectedCardLessEmi = cardlessEMI;
  this.selected_bank_emi_data = {
    name: cardlessEMI?.code,
  }
  this.selectedEmiPlan = {
    amountForMonth: 0,
    duration: 0,
  }
  this.makePayment();
}


displayTooltip() {
  if(this.deviceWidth<=992) {
    this.showEmiTooltip = true;
  }
}

closeTooltip() {
  if(this.deviceWidth<=992) {
    this.showEmiTooltip = false;
  }
}
// part payment 

doPartPayment() {
  this.paymentType = "partpayment";
  this.customPaymntType= "card";
  this.customPaymntPanelClose();
}

goToPayInPartsMenu() {
  this.paymentType = "fullpayment";
  this.customPaymntTypeEvent("pay_in_part");
}

// paylater

payLaterUsingICICI(method) {
  this.paymentGatewayCode = 'RAZORPAY';
  this.selectedPaylaterMethod = method;
  this.payValue(this.subscriptionbillingUtility.fullPaymentOptions?.amount,'fullpayment');
}

getIPAddress() {
  this.http.get("https://api.ipify.org/?format=json").subscribe((res:any)=>{
    this.ipAddress = res.ip;
  });
}

checkSimpleEligibility(type: any) {
  let userData = JSON.parse(
    localStorage.getItem(apisDataCacheKeys.userDetails)
  );
  const payload = {
    amount_in_paise: Math.round((this.subscriptionbillingUtility.emiPayLaterFulltotalAmount + Number.EPSILON) * 100),
    phone_number: userData.phone,
    device_params: {
      "simpl_ipa": this.ipAddress, 
      // 'SIMPL-AdId': '',
      // 'SIMPL-DEVICE-MANUFACTURER': '',
      // 'SIMPL-DEVICE-MODEL': '',
      // 'SIMPL-isR': '',
      // 'SIMPL-AndId': '',
      // 'SIMPL-IPA': '',
      // 'SIMPL-PAV': '',
      // 'SIMPL-InApp': '',
      // 'SIMPL-Ltln': '',
    },
  };
  this.SubscriptionService.checkUserSimpleEligibility(payload).subscribe((response: any) => {
    this.simplEligibilityData = response?.data;
    if (type == 'linking_required') {
      if(this.simplEligibilityData?.error_code != 'linking_required') {
        this.toastr.success('Simpl linked, click on Simpl to pay with Simpl');
      }
    } else if(
      type == 'insufficient_credit' ||
      type == 'pending_dues'
    ) {
      if(this.simplEligibilityData?.error_code == null && this.simplEligibilityData?.token) {
        this.createOrderAndPayUsingSimple();
      }
    }
  }, (err) => {
    console.log(err);
    this.simplEligibilityData = {
      error_code: "unable_to_process",
      status: "not_eligible"
     };
  });
}

payUsingSimpl() {
  if (
    this.simplEligibilityData?.error_code == 'linking_required' ||
    this.simplEligibilityData?.error_code == 'insufficient_credit' ||
    this.simplEligibilityData?.error_code == 'pending_dues'
  ) {
    this.spinner.show();
    this.openSimplWindow(this.simplEligibilityData?.error_code);
  } else if(this.simplEligibilityData?.error_code == null && this.simplEligibilityData?.token) {
    this.createOrderAndPayUsingSimple();
  }
}

openSimplWindow(errorCode: any) {
  if(this.allowOpeningSimplewindow) {
    this.simplWindow = window.open(
      this.simplEligibilityData?.redirection_url,
      '_blank',
      'toolbar=yes,scrollbars=yes,resizable=yes,top=300,left=300,width=800,height=600'
    );
    this.allowOpeningSimplewindow = false;
    var timer = setInterval(() => {
      if (this.simplWindow?.closed) {
        this.allowOpeningSimplewindow = true;
        console.log(this.simplWindow);
        clearInterval(timer);
        this.spinner.hide();
        this.checkSimpleEligibility(errorCode);
      }
    }, 1000);
  } else {
    this.simplWindow.focus();
  }
}

createOrderAndPayUsingSimple() {
  this.spinner.show();
  this.paymentGatewayCode = 'SIMPL';
  this.payValue(this.subscriptionbillingUtility.fullPaymentOptions?.amount,'fullpayment');
}

// custom payment event ended


// net banking search dropdown start
  displayFn(bankname: Bank): string {
    return bankname && bankname.name ? bankname.name : '';
  }
  private _filter(name: string): Bank[] {
    const filterValue = name.toLowerCase();

    return this.options.filter(option => option.name.toLowerCase().includes(filterValue));
  }
// net banking search dropdown ended

payUsingBajajWithOTP() {
  this.spinner.show();
  this.subcriptionPayment = this.subscriptionbillingUtility;
  var obj = {
    "gatewayCode": this.paymentGatewayCode,
    "paymentMode": "ONLINE",
    "razorpayOrderId": "",
    "razorpayPaymentId": "",
    "razorpaySignature": "",
    "userOrderId": this.subcriptionPayment.orderId,
    "batchId": this.subcriptionPayment?.selectedBatch?.id ?? '',
    "ruleID": this.subcriptionPayment.selectedPackage?.id ?? '',
    "userOrderPaymentPlanCaptureDetailsRequest": this.subcriptionPayment.payValue == 'fullpayment' ?
      [{
        "paidAmount": this.subcriptionPayment.fullPaymentOptions?.amount,
        "partAmount": this.subcriptionPayment.fullPaymentOptions?.amount,
        "partPlanDetailsId": this.subcriptionPayment.fullPaymentOptions?.planDetailId
      }]
      : this.subcriptionPayment.emiOptions?.map((val, index) => {
        return {
          "paidAmount": index == 0 ? val?.amount : 0,
          "partAmount": val?.amount,
          "partPlanDetailsId": val?.planDetailId
        }
      }) ?? [],
    "paymentPlanCaptureDetailsId": this.subcriptionPayment.payValue == 'fullpayment' ? this.subcriptionPayment.fullPaymentOptions?.planDetailId : this.subcriptionPayment.emiOptions?.[0]?.planDetailId,
    "bajajFinanaceDto": {
      "cardNumber": this.selctedBajajEMICardData?.cardNo,
      "ipAdd": this.ipAddress,
      "mobileNo": this.selctedBajajEMICardData?.phone,
      "nameOnCard": this.subcriptionPayment.userDetails.firstName + ' ' + this.subcriptionPayment.userDetails.lastName,
      "otp": this.selctedBajajEMICardData?.otp,
      "requestId": this.bajajCreateCartOrderResp?.requestId,
      "tanure": this.selectedEmiPlan?.duration?.toString(),
      "schemeId": this.selectedEmiPlan?.schemeId
    },
    jodoProductType: this.paymentGatewayCode == "JODO" ? this.jodoProductType : undefined,
  }
  const options = {
    name: this.subscriptionbillingUtility.userDetails.firstName + ' ' + this.subscriptionbillingUtility.userDetails.lastName,
    amount: 100, // razorpay takes amount in paisa
    prefill: {
      name: this.subscriptionbillingUtility.userDetails?.firstName + ' ' + this.subscriptionbillingUtility.userDetails?.lastName,
      email: this.subscriptionbillingUtility.userDetails?.email || '', // add your email id
      contact: this.subscriptionbillingUtility.userDetails?.phone 
    },
  }
  this.SubscriptionService.userPayment(obj).subscribe({
    next: (resp: any) => {
      if(resp?.bajajResponse?.RSPCODE == "0") {
        this.subscriptionbillingUtility.partnerPaymentSuccess = "success";
        this.redirectToPaymentVerificationPageAfterSimplAndBajajPaymentSuccess(this.subscriptionbillingUtility, resp, options)
      } else if(resp?.bajajResponse?.RESPDESC?.toLowerCase() == "INVALID OTP CODE"?.toLowerCase()) {
        this.BajajEMIOtpErrorMSg = resp?.message;
      } else {
        this.redirectToPaymentVerificationPageAfterSimplPaymentFailure(this.subscriptionbillingUtility, resp, options);
      }
      this.spinner.hide();
    }, error: (err) => {
      this.redirectToPaymentVerificationPageAfterSimplPaymentFailure(this.subscriptionbillingUtility, err, options);
      this.spinner.hide();
    },
  })
}
onPaymentFailure(subscriptionbillingUtility, options: any) {
  console.log(subscriptionbillingUtility);
  this.zone.run(() => {
    // add current page routing if payment fails
    this.subcriptionPayment = subscriptionbillingUtility;
    let emiData = this.subcriptionPayment.paidOptions;
    let planDetailsCapture = this.subcriptionPayment?.paidOptions?.[0];
    this.options = options;
    if (!subscriptionbillingUtility.selectedPackage) {
      subscriptionbillingUtility.selectedPackage = {};
    }
    subscriptionbillingUtility.selectedPackage.status = 'error';
    let routing = {
      billingAddress: subscriptionbillingUtility.billingAddress,
      selectedPin: subscriptionbillingUtility.selectedPin,
      selectedState: subscriptionbillingUtility.selectedState,
    };
    let body = {
      amount: subscriptionbillingUtility.selectedPackage?.amount,
      creationDate: new Date().toISOString(),
      status: 'aborted',
      userId: this.userDetails?.userId,
      userOrderId: subscriptionbillingUtility.orderId,
      grade: this.userDetails?.grade?.name?.replace(/[^0-9]/g, ''),
      reason: subscriptionbillingUtility?.error?.reason || "Payment processing cancelled by user",
      description: subscriptionbillingUtility?.error?.description || "Payment processing cancelled by user",
    };
    this.SubscriptionService.paymentABortedbyUser(body).subscribe((resp: any) => {
      console.log('aborted by user');
      $('#paymentfail').modal('show');
      // this.router.navigate(['./enroll-subscription/enroll-payementVerification'],
      //         { ...subscriptionbillingUtility.selectedPackage, ...this.subscriptionbillingUtility.selectedDuration, ...this.options, ...{ emiData: emiData }, ...{ planDetailsCapture: planDetailsCapture }, ...{ paymentStatusCapture: subscriptionbillingUtility.paymentStatusCapture }, ...{ productSet: this.subscriptionbillingUtility.selectedPackage.productSet }, ...{ selectedPaymentData: subscriptionbillingUtility.selectedPaymentData, ...{ failureMessage: resp?.failureMessage || subscriptionbillingUtility?.error?.description || "" }, } });
    });
    
  });
}

// Jodo Cred

createCrdlessEMICardForm() {
  this.CardlessEMICardForm = this.fb.group({
    phone: new FormControl(this.userDetails?.phone,[Validators.required, Validators.pattern('^([6-9][0-9]{9})$')]),
  });
}

openJodoCredForm() {
  this.zone.run(() => {
    this.paymentGatewayCode = "JODO";
    this.jodoProductType = "CRED";
    this.toggleInnerPanel('cardlessEmiFormPanel');
    this.createCrdlessEMICardForm();
  })
}

payUsingJodoCred() {
  // this.paymentGatewayCode = "JODO";
  // this.jodoProductType = "CRED";
  this.payValue(this.subscriptionbillingUtility?.emiPayLaterFulltotalAmount,'fullpayment');
}

doJodoPayment() {
  this.SubscriptionService.getJodoAccessToken(this.subscriptionbillingUtility.generatedOrderDetails?.fintechResponse?.registration_id)
  .subscribe((res: any) => {
    this.subscriptionbillingUtility.generatedOrderDetails.jodoAccessTokenData = res?.data;
    localStorage.setItem("jodoAccessTokenData", JSON.stringify(res.data));
    this.openJodoWindow();
  })
  // const accessTokenData = localStorage.getItem("jodoAccessTokenData") ? JSON.parse(localStorage.getItem("jodoAccessTokenData")) : null;
  // if(!accessTokenData || !(new Date().getTime() < new Date(accessTokenData?.expires_at).getTime())){
  //   this.SubscriptionService.getJodoAccessToken(this.subscriptionbillingUtility.generatedOrderDetails?.fintechResponse?.registration_id)
  //     .subscribe((res: any) => {
  //       this.subscriptionbillingUtility.generatedOrderDetails.jodoAccessTokenData = res?.data;
  //       localStorage.setItem("jodoAccessTokenData", JSON.stringify(res.data));
  //       this.openJodoWindow();
  //     })
  // } else {
  //   this.subscriptionbillingUtility.generatedOrderDetails.jodoAccessTokenData = accessTokenData;
  //   this.openJodoWindow();
  // }
}

openJodoWindow() {
  const jodoWebsiteRedirectionUrl = `${environment?.Jodo?.jodo_auth_host}/consumer/login-redirect?access_token=${this.subscriptionbillingUtility?.generatedOrderDetails?.jodoAccessTokenData?.access_token}&jodo_student_id=${this.subscriptionbillingUtility.generatedOrderDetails?.fintechResponse?.jodo_student_id}&product_type=${this.jodoProductType.toLowerCase()}`;
  let dialogRef = this.dialog.open(PaymentPartnerIframeDialogComponent, { width: '979px', panelClass: ['jodo-cred-dialog', 'payment-partner-iframe-dialog'], disableClose: true, data: { redirectionUrl: jodoWebsiteRedirectionUrl, productType: this.jodoProductType } });
  this.spinner.hide();
  dialogRef.afterClosed().subscribe((value) => {
    this.spinner.show();
    setTimeout(() => {
      this.checkJodoPaymentStatus();
    }, 2000);
  });
  // this.jodoPopupWindow = window.open(
  //   jodoWebsiteRedirectionUrl,
  //   '_blank',
  //   'toolbar=yes,scrollbars=yes,resizable=yes,top=300,left=300,width=800,height=600'
  // );
  // this.spinner.hide();

  // if(this.jodoPopupWindow) {
  // let dialogRef = this.dialog.open(JodoPopupInfoDialogComponent, { width: '440px', panelClass: 'jodo-cred-dialog', disableClose: true, data: this.jodoProductType == "CRED" ? "Jodo Cred" : "Jodo Flex" });

  //   var timer = setInterval(() => {
  //     if (this.jodoPopupWindow?.closed) {
  //       clearInterval(timer);
  //      dialogRef.close();
  //      this.spinner.show();
  //       this.checkJodoPaymentStatus();
  //     } else {
  //     }
  //   }, 5000);
  // } else {
  //    // Popup is blocked
  //       // this.spinner.hide();
  // }
}
checkJodoPaymentStatus() {
  const options = {
    name: this.subscriptionbillingUtility.userDetails.firstName + ' ' + this.subscriptionbillingUtility.userDetails.lastName,
    amount: 100,
    prefill: {
      name: this.subscriptionbillingUtility.userDetails?.firstName + ' ' + this.subscriptionbillingUtility.userDetails?.lastName,
      email: this.subscriptionbillingUtility.userDetails?.email || '',
      contact: this.subscriptionbillingUtility.userDetails?.phone 
    },
  }
  let user: any = localStorage.getItem(apisDataCacheKeys.userDetails);
   user = localStorage.getItem(apisDataCacheKeys.userDetails)
     ? JSON.parse(user)
     : {};
   this.SubscriptionService.getJodoPaymentStatus(this.subscriptionbillingUtility.generatedOrderDetails?.orderId, this.jodoProductType.toLowerCase(), this.subscriptionbillingUtility.generatedOrderDetails?.fintechResponse?.jodo_student_id, Number(user?.grade?.name?.replace(/[^0-9]/g, '')), user?.userId).subscribe((response: any) => {
     
    if(this.jodoProductType == "CRED") {
 if(response?.status == "success" && (response?.data?.[0]?.status == "application_started" || response?.data?.[0]?.status == "application_filled")) {
        this.subscriptionbillingUtility.partnerPaymentSuccess = "processing";
        this.redirectToPaymentVerificationPageAfterSimplAndBajajPaymentSuccess(this.subscriptionbillingUtility, response, options)
      } else {
        this.redirectToPaymentVerificationPageAfterSimplPaymentFailure(this.subscriptionbillingUtility, { gatewayData: response }, options);
      }
    } else if(this.jodoProductType == "FLEX") {
      if(response?.status == "success" && response?.data?.[0]?.status == "locked" && response?.isDownpayment) {
        this.subscriptionbillingUtility.partnerPaymentSuccess = "success";
        this.redirectToPaymentVerificationPageAfterSimplAndBajajPaymentSuccess(this.subscriptionbillingUtility, response, options)
      } else if(response?.status == "success" && (response?.data?.[0]?.status == "pending" || response?.data?.[0]?.status == "locked")) {
        this.subscriptionbillingUtility.partnerPaymentSuccess = "processing";
        this.redirectToPaymentVerificationPageAfterSimplAndBajajPaymentSuccess(this.subscriptionbillingUtility, response, options)
      } else {
        this.redirectToPaymentVerificationPageAfterSimplPaymentFailure(this.subscriptionbillingUtility, { gatewayData: response }, options);
      }
    }
    this.spinner.hide();
  }, (err) => {
    this.redirectToPaymentVerificationPageAfterSimplPaymentFailure(this.subscriptionbillingUtility, { gatewayData: err }, options);
    this.spinner.hide();
  })
}

openShopseForm() {
  this.zone.run(() => {
    this.paymentGatewayCode = "SHOPSE";
    this.toggleInnerPanel('cardlessEmiFormPanel');
    this.createCrdlessEMICardForm();
  })
}

payUsingShopse() {
  // this.paymentGatewayCode = "SHOPSE";
  this.payValue(this.subscriptionbillingUtility.emiPayLaterFulltotalAmount,'fullpayment');
}

doShopsePayment() {
  localStorage.removeItem("shopseEncryptedData");
  localStorage.setItem("allowOrderProcessingWindowClose", "true");
  const shopseWebsiteRedirectionUrl = this.subscriptionbillingUtility?.generatedOrderDetails?.fintechResponse?.paymentRedirectUrl;
  this.shopsePopupWindow = window.open(
    shopseWebsiteRedirectionUrl,
    '_blank',
    'toolbar=yes,scrollbars=yes,resizable=yes,top=300,left=300,width=800,height=600'
  );
  if(this.shopsePopupWindow) {
    var timer = setInterval(() => {
      if (this.shopsePopupWindow?.closed) {
        clearInterval(timer);
        if(localStorage.getItem("shopseEncryptedData")) {
          this.checkShopsePaymentStatus("windowAutomaticallyClosed");
        } else {
          this.checkShopsePaymentStatus("windowForcefullyClosed");
        }
      }
    }, 5000);
  } else {
    localStorage.removeItem("allowOrderProcessingWindowClose");
    this.spinner.hide();
  }
}

getOptions() {
  return {
    name: this.subscriptionbillingUtility.userDetails.firstName + ' ' + this.subscriptionbillingUtility.userDetails.lastName,
    amount: 100,
    prefill: {
      name: this.subscriptionbillingUtility.userDetails?.firstName + ' ' + this.subscriptionbillingUtility.userDetails?.lastName,
      email: this.subscriptionbillingUtility.userDetails?.email || '',
      contact: this.subscriptionbillingUtility.userDetails?.phone 
    },
  };
} 
checkShopsePaymentStatus(type) {
  const options = this.getOptions();
  const encryptionResponse = type == "windowAutomaticallyClosed" ? localStorage.getItem("shopseEncryptedData") || "" : "";
  this.SubscriptionService.getShopseDecryptedData(encryptionResponse, this.subscriptionbillingUtility.generatedOrderDetails?.orderId).subscribe((response: any) => {
    localStorage.removeItem("shopseEncryptedData");
    localStorage.removeItem("allowOrderProcessingWindowClose");
    if(type == "windowAutomaticallyClosed") {
      const arr = response?.shopseResponse?.split("&") || [];
      arr?.forEach(e => {
        if(e?.includes("statusMessage")) {
          response.message = e?.split("=")?.[1];
        }
      });
    } else {
      response.message = "Payment processing cancelled by user"
    }
    if(response?.shopseResponse?.toLowerCase()?.includes("status=success") || response?.shopseTransactionStatus == "success") {
      this.subscriptionbillingUtility.partnerPaymentSuccess = "success";
      this.redirectToPaymentVerificationPageAfterSimplAndBajajPaymentSuccess(this.subscriptionbillingUtility, response, options)
    } else {
      this.redirectToPaymentVerificationPageAfterSimplPaymentFailure(this.subscriptionbillingUtility, { gatewayData: response }, options);
    }
    this.spinner.hide();
  }, (err) => {
    localStorage.removeItem("shopseEncryptedData");
    this.redirectToPaymentVerificationPageAfterSimplPaymentFailure(this.subscriptionbillingUtility, { gatewayData: err }, options);
    this.spinner.hide();
  })
}
// part payment 

doInfinityPartPayment() {
  this.paymentType = "partpayment";
  this.customPaymntType= "card";
  this.customPaymntPanelClose();
}

doJodoPartPayment() {
  let temp_payment_schedule = [];
  this.subscriptionbillingUtility?.jodoemiOptions?.forEach((eachPartPament) => {
    console.log(eachPartPament);
  temp_payment_schedule.push({
          "due_date": moment(eachPartPament?.lastdate).format('YYYY-MM-DD'),
          "details": [{"detail_type": "COURSE_FEE","component_type": "COURSE_FEE","amount": Math.round((eachPartPament?.amount + Number.EPSILON) * 100) / 100 }]
        })
  });
  temp_payment_schedule?.sort((a,b) => new Date(a.due_date).getTime()-new Date(a.due_date).getTime());
  this.subscriptionbillingUtility.jodo_payment_schedule = temp_payment_schedule;
  if(this.subscriptionbillingUtility.jodo_payment_schedule.length) {
    this.subscriptionbillingUtility.jodo_payment_schedule[0].is_downpayment = true;
  }
  console.log(this.subscriptionbillingUtility?.jodo_payment_schedule);
  this.paymentGatewayCode = "JODO";
  this.jodoProductType = "FLEX";
  this.payValue((this.subscriptionbillingUtility.jodoemiOptions?.length)?(this.subscriptionbillingUtility.jodoemiOptions[0].amount):0,'partpayment')
}

isTryAgainEmi(){
  this.isTryAgain = false;
}

createEarlySalaryEMICardForm() {
  this.EarlySalaryEMICardForm = this.fb.group({
    phone: new FormControl(this.userDetails?.phone,[Validators.required, Validators.pattern('^([6-9][0-9]{9})$')]),
    esConsent: new FormControl(false,[Validators.required]),
  });
  this.EarlySalaryEMICardForm.get("phone")!.valueChanges.subscribe((value) => {
    this.EarlySalaryEMICardErrorMSg = "";
  });
}

goToEarlySalaryForm() {
  this.zone.run(() => {
    this.paymentGatewayCode = "EARLY_SALARY";
    this.toggleInnerPanel('earlySalaryFormPanel');
    this.createEarlySalaryEMICardForm();
  })
}


payUsingEarlySalaryNoCostEMI() {
  this.payValue(this.subscriptionbillingUtility?.emiPayLaterFulltotalAmount,'fullpayment');
}

doEarlySalaryPayment() {
  localStorage.removeItem("shopseEncryptedData");
  localStorage.setItem("allowOrderProcessingWindowClose", "false");
  const earlySalaryWebsiteRedirectionUrl = this.subscriptionbillingUtility?.generatedOrderDetails?.fintechResponse?.earlySalaryResponse?.bitlyUrl;
  let dialogRef = this.dialog.open(PaymentPartnerIframeDialogComponent, { width: '979px', panelClass: ['jodo-cred-dialog', 'payment-partner-iframe-dialog'], disableClose: true, data: { redirectionUrl: earlySalaryWebsiteRedirectionUrl, productType: "EARLY_SALARY" } });
  this.spinner.hide();
  dialogRef.afterClosed().subscribe((value) => {
    this.spinner.show();
    this.checkEarlySalaryPaymentStatus();
    localStorage.removeItem("shopseEncryptedData");
    localStorage.removeItem("allowOrderProcessingWindowClose");
  });
  // localStorage.removeItem("shopseEncryptedData");
  // const earlySalaryWebsiteRedirectionUrl = this.subscriptionbillingUtility?.generatedOrderDetails?.fintechResponse?.earlySalaryResponse?.bitlyUrl;
  // this.earlySalaryPopupWindow = window.open(
  //   earlySalaryWebsiteRedirectionUrl,
  //   '_blank',
  //   'toolbar=yes,scrollbars=yes,resizable=yes,top=300,left=300,width=800,height=600'
  // );
  // if(this.earlySalaryPopupWindow) {
  //   var timer = setInterval(() => {
  //     if (this.earlySalaryPopupWindow?.closed) {
  //       clearInterval(timer);
  //       this.checkEarlySalaryPaymentStatus();
  //       localStorage.removeItem("shopseEncryptedData");
  //     }
  //   }, 5000);
  // } else {
  //   this.spinner.hide();
  // }
}

checkEarlySalaryPaymentStatus() {
  const options = this.getOptions();
  const payload = {
    "lead_id": this.subscriptionbillingUtility?.generatedOrderDetails?.fintechResponse?.earlySalaryResponse?.leadId,
    "applicationNo": this.subscriptionbillingUtility?.generatedOrderDetails?.fintechResponse?.earlySalaryResponse?.transactionId,
    "transactionNo": this.subscriptionbillingUtility?.generatedOrderDetails?.orderId,
  };
  let user: any = localStorage.getItem(apisDataCacheKeys.userDetails);
   user = localStorage.getItem(apisDataCacheKeys.userDetails)
     ? JSON.parse(user)
     : {};
     this.SubscriptionService.getEarlySalaryStatus(payload, this.subscriptionbillingUtility.generatedOrderDetails?.orderId, Number(user?.grade?.name?.replace(/[^0-9]/g, '')), user?.userId).subscribe((response: any) => {
      if(response?.status == "success" && response?.esStatus != "ES_DISBURSED" && response?.esStatus != "ES_REJECT") {
        this.subscriptionbillingUtility.partnerPaymentSuccess = "processing";
        this.redirectToPaymentVerificationPageAfterSimplAndBajajPaymentSuccess(this.subscriptionbillingUtility, response, options)
      } else if(response?.status == "success" && response?.esStatus == "ES_DISBURSED") {
        this.subscriptionbillingUtility.partnerPaymentSuccess = "success";
        this.redirectToPaymentVerificationPageAfterSimplAndBajajPaymentSuccess(this.subscriptionbillingUtility, response, options)
      } else {
        this.redirectToPaymentVerificationPageAfterSimplPaymentFailure(this.subscriptionbillingUtility, { gatewayData: response }, options);
      }
      this.spinner.hide();
    }, (err) => {
      this.redirectToPaymentVerificationPageAfterSimplPaymentFailure(this.subscriptionbillingUtility, { gatewayData: err }, options);
      this.spinner.hide();
    });
}

tryagaina(){
  $('#paymentfail').modal('hide');
}

getExistPackagesOrderDetail(id){
  this.spinner.show();
  this.SubscriptionService.getExistPackagesOrderDetail(id).subscribe((resp:any)=>{
    let response = resp;
    response?.forEach(e=>{
      e.expiryDate = new Date(e?.expiryDate); 
      let today = new Date();
      e.packageIsExpired = e.expiryDate < today ? true : false;
    });
    let findsubscription = response?.find(ele=>!ele?.packageIsExpired);
    if((findsubscription?.userOrder?.status?.code ==='APPLICATION_STARTED' || findsubscription?.userOrder?.status?.code==='FINAL_APPROVED' ||
    findsubscription?.userOrder?.status?.code ==='APPLICATION_FILLED') && findsubscription?.userOrder?.paymentType === 'CRED'){
      this.isJodoflex = true;
      let dialogRef = this.dialog.open(
        JodoPopupComponent,
        {
          height: '160px',
          width: '500px',
          data: {
            message1: "The package you have selected is pending for EMI approval from Jodo Cred. Please visit 'My Subscriptions' page to find the live status of your application.",
            btnname:'MY SUBSCRIPTIONS',
            direction:'/dashboard/subscribedPackages',
            isPropackage: false
          },
          disableClose: true
        }
      );
      this.spinner.hide();
    } else if((findsubscription?.userOrder?.status?.code ==='ES_LEAD_CREATED' || findsubscription?.userOrder?.status?.code==='ES_IN_PROGRESS' ||
    findsubscription?.userOrder?.status?.code ==='ES_KYC_DONE' || findsubscription?.userOrder?.status?.code ==='ES_LEAD_UPDATE' ||
    findsubscription?.userOrder?.status?.code ==='ES_KYC_CANCEL' || findsubscription?.userOrder?.status?.code ==='ES_APPROVED') && findsubscription?.userOrder?.paymentType === 'EARLY_SALARY'){
      this.isJodoflex = true;
      let dialogRef = this.dialog.open(
        JodoPopupComponent,
        {
          height: '160px',
          width: '500px',
          data: {
            message1: "The package you have selected is pending for EMI approval from Fibe (formerly EarlySalary). Please visit 'My Subscriptions' page to find the live status of your application.",
            btnname:'MY SUBSCRIPTIONS',
            direction:'/dashboard/subscribedPackages',
            isPropackage: false
          },
          disableClose: true
        }
      );
      this.spinner.hide();
    } else if(findsubscription?.userOrder?.status?.code ==='PENDING' || findsubscription?.userOrder?.status?.code==='LOCKED'){
      this.isJodoflex = true;
      let dialogRef = this.dialog.open(
        JodoPopupComponent,
        {
          height: '160px',
          width: '500px',
          data: {
            message1: "The package you have selected already has a Jodo Flex application pending. Please visit 'My Subscriptions' and resume the Jodo Flex part payments.",
            btnname:'MY SUBSCRIPTIONS',
            direction:'/dashboard/subscribedPackages',
            isPropackage: false
          },
          disableClose: true
        }
      );
      this.spinner.hide();
    } else if((findsubscription?.userOrder?.status?.code ==='AGREEMENT_SIGNED' || findsubscription?.userOrder?.status?.code ==='LOAN_DISBURSED' || findsubscription?.userOrder?.status?.code ==='PAID') && findsubscription?.paymentType === 'CRED'){
      let dialogRef = this.dialog.open(
        JodoPopupComponent,
        {
          height: '160px',
          width: '500px',
          data: {
            message1: 'The package you have selected has already been subscribed through Jodo Cred. Please visit Live Class, Self Learn or Test section to access your package.',
            btnname:'HOME',
            direction:'/dashboard',
            isPropackage: false
          },
          disableClose: true
        }
      );
      this.isJodoflex = true;
      this.spinner.hide();
    } else if((findsubscription?.userOrder?.status?.code ==='AGREEMENT_SIGNED' || findsubscription?.userOrder?.status?.code ==='ES_DISBURSED' || findsubscription?.userOrder?.status?.code ==='PAID') && findsubscription?.userOrder?.paymentType === 'EARLY_SALARY'){
      let dialogRef = this.dialog.open(
        JodoPopupComponent,
        {
          height: '160px',
          width: '500px',
          data: {
            message1: 'The package you have selected has already been subscribed through Fibe (formerly EarlySalary). Please visit Live Class, Self Learn or Test section to access your package.',
            btnname:'HOME',
            direction:'/dashboard',
            isPropackage: false
          },
          disableClose: true
        }
      );
      this.isJodoflex = true;
      this.spinner.hide();
    } else if(findsubscription?.userOrder?.status?.code ==='PAID' && findsubscription?.userOrder?.status?.id == 3){
      this.isJodoflex = true;
      let dialogRef = this.dialog.open(
        JodoPopupComponent,
        {
          height: '220px',
          width: '500px',
          data: {
            message2: 'Oops!',
            message1: 'You are already enrolled to this package',
            btnname:'HOME',
            direction:'/dashboard',
            isPropackage: true
          },
          disableClose: true
        }
      );
      this.spinner.hide();
    } else if((findsubscription?.userOrder?.status?.code ==='REJECTED' && findsubscription?.userOrder?.paymentType === 'CRED') || (findsubscription?.userOrder?.status?.codee ==='ES_REJECT' && findsubscription?.userOrder?.paymentType === 'EARLY_SALARY')){
      this.isJodoflex = false;
      this.spinner.hide();
    } else {
      this.isJodoflex = false;
      this.spinner.hide();
    }
  })
}

checkForBooksPackage(){
  
  this.subscriptionbillingUtility.freeProPackageAmount = 0;
  var booksPackage = this.subscriptionbillingUtility.allCartItems?.filter(v=> v.product?.id == Oms_package_id.booksPackage)
  console.log(booksPackage);
  
  let params = {
    examName:this.subscriptionbillingUtility?.selectedPackage?.examName,
    grade:(JSON.parse(localStorage.getItem('user_details_from_server'))?.grade?.name?.replace(/[^0-9]/g, '' )),
    productId:Oms_package_id.free_pro_package
  }
  this.SubscriptionService.getSpecialDiscountSubscription(params).subscribe((resp:any)=>{
    console.log('resp: ', resp);
    let productIds = [... new Set(resp?.map(v=>v?.packages?.id))]
    resp = resp.sort(function(a, b){return a.amount - b.amount});
    let newResponse = [];
     productIds.forEach(id=>{
      newResponse.push( resp.find(v=>v?.packages?.id == id))
    })
    this.subscriptionbillingUtility.freeProPackageAmount = newResponse?.map(v=>v?.amount).reduce((a, b) => a + b, 0);
    if(newResponse?.length == 0){
      this.subscriptionbillingUtility.freeProPackageAmount = this.subscriptionbillingUtility.freeProPackageAmount+((1)*basic_propackage?.amount) 
    }
      this.subscriptionbillingUtility.freeBooksPackageList = newResponse;
      this.calculateEmioptions();
    
  })
  }

getSelectedCartItem(cartId){
  const userGrade = this.subscriptionbillingUtility?.localUserData?.grade?.name?.replace(/[^0-9]/g,'');
  let cartbody = {
    grade: userGrade,
    userId: this.subscriptionbillingUtility.localUserData?.userId
  }
  this.SubscriptionService.getAllCartItems(cartbody).subscribe((resp:any)=>{
    this.spinner.show();
    this.selectedCartItem = resp?.find(e=>e.id == cartId);
    console.log(this.selectedCartItem, 'cart data');
    this.spinner.hide();
  });
}

}
